import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
    Field, reduxForm, change, FieldArray,
    formValueSelector, stopAsyncValidation, touch, reset
} from 'redux-form'
import { getFormValues } from 'redux-form/immutable'
import { DefaultPlayer as Video } from 'react-html5video'
import map from 'async/map'
import isEmpty from 'lodash/isEmpty'
import bindAll from 'lodash/bindAll'
import Promise from 'bluebird'
import $ from 'jquery'
import snakeCase from 'voca/snake_case'
import UAParser from 'ua-parser-js'
import imgDefaultLogo from '../../../images/public/company_empty.png'
import AstronautLogo from '../../../styles/img/astronaut-logo.png'
import imgSubmitted from '../../../images/submitted.svg'
import imgAppStore from '../../../images/public/appstore.png'
import imgGooglePlay from '../../../images/public/googleplay.png'
import RenderSelectMulti from '../../partials/RenderSelectMulti'
import RenderTagsInput from '../../partials/RenderTagsInput'
import imgAstrntFooter from '../../../images/public/logo-astronaut.svg'
import logoX from '../../../images/x.svg'
import CheckBoxGroup from '../../partials/CheckBoxGroup'
import RenderSelect from '../../partials/RenderSelect'
import RadioButtonGroup from '../../partials/RadioButtonGroup'
import RenderInput from '../../partials/RenderInput'
// import validate from './validate'
import validate from './customValidation'
import { Map, fromJS } from 'immutable'
// import Swal from 'sweetalert2'
import _axios from '../../../dependencies/_axios'

// import { EmailShareButton, FacebookShareButton, TwitterShareButton, LinkedinShareButton, WhatsappShareButton } from 'react-share'
import moment from 'moment'
import {
    publicTalentPoolGetDetailCode,
    registrationSaveData,
    publicJobGetDetailAsync,
    registrationSaveDataError,
    publicJobGetDetail,
    registrationTalentPoolSaveDataCode
} from '../../../actions/public/companies'


import {
    t,
    translate,
    checkLink,
    GDDRIVE_DOMAIN,
    YT_DOMAIN,
    downloadAndCheckGdrive,
    downloadAndCheckYoutube,
    downloadAndCapturePages,
    getFormatExtension,
} from '../../../helpers/global'

import {
    globalHideSweetAlert,
    globalAddSweetAlertData
} from '../../../actions/global'

import {
    docAttachment,
    docAttachmentUpload,
    docAttachmentCV,
    send,
} from '../../../actions/public/document'

import { accessLog } from '../../../actions/global'
import ImgError404 from '../../../images/404.svg'
import FileUploader from '../../partials/FileUploader'
import LinkInputer from '../../partials/LinkInputer'
import ReceivedAplication from '../../partials/ReceivedAplication'

import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
require('es6-promise').polyfill()
export const fields = ['file']

type State = {
    isConsent: boolean,
    isSaved: boolean
};

const ACCEPTED_MULTI_DOC = [
    'pdf', 'doc', 'docx', 'ppt', 'pptx', 'txt', 'rtf', 'odf', 'odt', 'xls', 'xlsx', 'ods', 'csv',
    'jpg', 'jpeg', 'png', 'bmp', 'tiff', 'svg', 'gif', 'mp3', 'ogg', 'flv', 'f4v', 'mp4', 'mov', 'avi', 'mpeg',
    'rar', 'zip', 'xd', 'ai', 'psd', 'indd', 'aep', 'prproj', 'swf', 'fig', 'sketch', 'cdr', 'dwg', 'dxf', 'raw', 'eps', 'blend',
    'c4d', 'skp', 'rva', 'rvt', '3ds', 'pln', 'pla', 'stp', 'obj', 'fbx'
];

const ACCEPTED_PDF_DOC = [
    'application/pdf',
    'image/jpeg',
];

const normalizeEmail = (value, previousValue) => {
    return value.trim()
}

const renderTime = (job) => {
    return job.timezone ? job.timezone.suffix : '(GMT+7)'
}

var timeOutCheckLink = null

const normalizeTextLenght = (value, previousValue, maxWords) => {
    let countText;
    if (value.trim().length == 0) {
        countText = 0;
    } else {
        countText = value == "" ? 0 : value.match(/\S+/g).length;
    }

    if (countText <= maxWords) {
        return value
    } else {
        return previousValue
    }
}


const regexLinkCheck = (value) => {
    // var expression =/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
    var expression = /^(http|https):\/\//;
    var regex = new RegExp(expression);

    if (value.match(regex)) {
        return true
    } else {
        return false
    }
}

const validateDoc = (value, allValues, props) => {
    // naturally you do something else here if the value
    // used to determine whether this field is required or
    // not is not managed by the same redux form
    const isRequired = allValues.commentRequired === 'Yes'

    if (isRequired && !value) return "Can't be empty."
}


const getExt = (files) => {
    let fileName = files.name
    fileName = fileName.substr(fileName.lastIndexOf('.') + 1)
    return fileName
};

const getFilename = (files) => {
    let fileName = files.name
    fileName = fileName.substring(0, fileName.lastIndexOf('.'))
    return fileName
};

let pollingUpload = null



/**
 * Formalize file.slice
 */

function slice(file, start, end) {
    var slice = file.mozSlice ? file.mozSlice :
        file.webkitSlice ? file.webkitSlice :
            file.slice ? file.slice : noop;

    return slice.bind(file)(start, end);
}

function noop() {

}

const normalizeNumberLength = (value, previousValue, min, max) => {
    let newVal = parseInt(value)
    let isValid = true;
    if (max) {
        if (newVal > max) {
            isValid = false
        }
    } else if (min) {
        if (newVal < min) {
            isValid = false
        }
    }

    if (isValid) {
        return value
    } else {
        return previousValue
    }
}

class CompanyTalentPoolByCode extends Component {
    constructor(props) {
        super(props)

        this.state = {
            file: '',
            experience: '0',
            name: '',
            email: '',
            code: '',
            url: '',
            isConsent: false,
            isCompliance: false,
            isSaved: false,
            uploadFilePercentage: '',
            testColor: '#564FDB',
            uploadProgress: '',
            cvName: '',
            isWhatsappReminder: true,
            error_exist: false,
            formDocumentList: [],
            targetIndexUpload: '',
            lastAttachmentIndex: 0,
            showPopUp: 0,
            show_received_application: 0,
            currentAdditionalFieldIndex: '',
            tempAdditionalFields: [],
            showSkillsForms: false,
        }
        this.uploadRef = React.createRef();
        this.uploadAdditionalFieldRef = React.createRef();

        bindAll(this, [
            'handleSaveData',
            'imageOnError',
            'renderError',
            'renderErrorCV',
            'removeRegexCharacter',
            'handleFileUpload',
            'checkExperience',
            'removeSpaceCharacter',
            'handleConsentClick',
            'handleClickAfterSave',
            'handleFileSave',
            'handleChangeTextArea',
            'inputFocus',
            'inputBlur',
            'handlePopUp',
            'countWord',
            'resizeTextArea',
            'removeErrorMessage',
            'handleWhatsappReminderClick',
            'renderMultiDocForm',
            'addLinkInputerForm',
            'handleRemoveInputLink',
            'handleFieldLinkChange',
            'checkCanAddFieldLink',
            'checkLinkErrorValue',
            'renderErrorNoTranslation',
            'handleAttachmentUpload',
            'uploadAttachments',
            'handleRemoveFile',
            'handleReuploadFile',
            'handleCancelUpload',
            'processFile',
            "promisedSetState",
            "renderErrorFileState",
            "showPopUpModal",
            "decidePage",
            "renderAdditionalField",
            "renderErrorAdditionalField",
            "handleAdditionalFileSave",
            "handleChangeAdditionalFieldValue",
            "handleRemoveAdditionalFieldValue",
            "renderErrorFile",
            "renderCVupload",
            "dragOver",
            "dragEnter",

        ])
    }

    decidePage(
        customColor,
        backgroundImage,
        company,

        job,
        show_due_date,
        dueDate,
        translations,
    ) {
        var show = []
        if (this.state.show_received_application) {
            show.push(
                <ReceivedAplication
                    candidate_name={this.state.name}
                    customColor={customColor}
                    backgroundImage={backgroundImage}
                    company={company}
                    imageOnError={this.imageOnError}
                    job={job}
                    show_due_date={show_due_date}
                    dueDate={dueDate}
                    renderTime={renderTime}
                    translations={translations}
                    isEmpty={isEmpty}
                />
            )
        }
        return show
    }

    //this function to be used as await
    promisedSetState(newState) {
        return new Promise(resolve => this.setState(newState, resolve));
    }

    showPopUpModal() {
        const { globalAddSweetAlertData, globalHideSweetAlert, translationjob } = this.props
        const translation: Map<string, any> = fromJS(translationjob.translation)
        if (this.state.showPopUp == 0) {
            this.setState({ showPopUp: 1 })
            globalAddSweetAlertData({
                show: true,
                title: t(translation, 'LONGER_TO_UPLOAD_TITLE_LANDING_PAGE'),
                html: true,
                text: t(translation, 'LONGER_TO_UPLOAD_DESC'),
                confirmButtonText: 'OK',
                confirmButtonColor: '#564FDB',
                onConfirm: () => {
                    globalHideSweetAlert()
                }
            })
        }
    }

    processFile(files, company_id, reducerIndex, indexDocument, indexAttachment, startData = null, new_file = 0) {
        const { send } = this.props
        var file = files;
        var extension = `.${getExt(files)}`
        var fileName = getFilename(files)
        var size = file.size;
        // var sliceSize = 25600;
        var isNewFile = new_file
        var sliceSize = 1000024;
        var start = 0;
        if (startData) {
            start = startData
        }
        let $this = this
        var lastData = 0
        // pollingUpload = setTimeout(loop, 300);

        // let $this = this
        function loop() {
            var end = start + sliceSize;

            if (size - end < 0) {
                end = size;
            }

            //expect datanya as string 
            //ex: bisa di liat di qna proctoring sendBlobAsBase64
            var s = slice(file, start, end);
            //case dipause ambil start dan end variable sebelum di read
            //nanti bisa continue dengan start end nya saatdicancel
            const reader = new FileReader();

            reader.addEventListener("load", () => {
                const dataUrl = reader.result;
                const base64EncodedData = dataUrl.split(",")[1];

                /**Needed if for example usage */
                //dataUrl.split(",")[2] for video
                //dataUrl.split(",")[1] for audio
                //example below video
                // const encodedData = dataUrl.split(',')[2];
                // const base64EncodedData = opus + ',' + encodedData

                send(company_id, base64EncodedData, extension, fileName, reducerIndex, end, start, size, isNewFile).then((res) => {
                    if (res == 'longupload') {
                        $this.showPopUpModal()
                    }
                    if (end < size) {
                        start += sliceSize;
                        isNewFile = 0
                        // originFormDocumentList[indexDocument].attachment[indexAttachment].pollingFunc = setTimeout(loop, 300);
                        // await $this.promisedSetState({formDocumentList:originFormDocumentList})
                        loop()
                        // pollingUpload=setTimeout(loop, 100);
                    }
                })
                    .catch((error) => {
                        $this.showPopUpModal()
                    })
            });

            reader.readAsDataURL(s);



            // if (end < size) {
            // 	start += sliceSize;
            // 	originFormDocumentList[indexDocument].attachment[indexAttachment].pollingFunc = setTimeout(loop, 300);
            // 	await $this.promisedSetState({formDocumentList:originFormDocumentList})

            // 	// pollingUpload=setTimeout(loop, 100);
            // }
        }
        loop()
    }

    handleCancelUpload(e, identifier, indexDocument, indexAttachment) {
        const {
            publicJobDetail,
            docAttachmentUpload,
            docAttachmentCV,
            docAttachment,
            documentAttachment,
        } = this.props

        // let originFormDocumentList = this.state.formDocumentList
        // if (originFormDocumentList[indexDocument].attachment[indexAttachment].pollingFunc) {
        //   clearTimeout(originFormDocumentList[indexDocument].attachment[indexAttachment].pollingFunc);
        // }


        let indexFileAttached = 0
        let result = documentAttachment.file_attachment.map((val, index) => {

            if (val.identifier == identifier) {
                indexFileAttached = index
                return val
            }
        })

        const current_files = documentAttachment.file_attachment
        const tokenCancel = current_files[indexFileAttached]['tokenCancel']
        if (tokenCancel) {
            tokenCancel.cancel('canceled')
            current_files[indexFileAttached]['status'] = 'failed'
            docAttachment(current_files)
        }


    }

    handleReuploadFile(e, identifier, indexDocument, indexAttachment) {
        const {
            publicJobDetail,
            docAttachmentUpload,
            docAttachmentCV,
            docAttachment,
            documentAttachment,
        } = this.props
        let company = publicJobDetail.company
        // let formDocumentList =  this.state.formDocumentList[indexDocument].attachment[]
        let originFormDocumentList = this.state.formDocumentList
        originFormDocumentList[indexDocument].attachment[indexAttachment].errorMessage = '';
        this.setState({ formDocumentList: originFormDocumentList })

        let indexFileAttached = 0
        let result = documentAttachment.file_attachment.map((val, index) => {

            if (val.identifier == identifier) {
                indexFileAttached = index
                return val
            }
        })

        const current_files = documentAttachment.file_attachment
        current_files[indexFileAttached]['status'] = 'loading'
        let sizeUnit = current_files[indexFileAttached]['sizeUnit']
        let startSize = current_files[indexFileAttached]['startSize']
        docAttachment(current_files)
            .then(() => {
                if (sizeUnit == 'MB') {
                    this.processFile(current_files[indexFileAttached]['originalFile'], company.id, indexFileAttached, indexDocument, indexAttachment, startSize)
                } else {
                    docAttachmentCV(company.id, current_files[indexFileAttached]['originalFile'], indexFileAttached, indexDocument)
                }
            })
    }

    handleRemoveFile(e, indexDocument, indexAttachment) {
        const { changeFieldValue } = this.props;

        let formDocumentList = this.state.formDocumentList[indexDocument]
        let originFormDocumentList = this.state.formDocumentList
        const current_files = formDocumentList.attachment
        formDocumentList.attachment = current_files.filter((val, ind) =>
            ind !== indexAttachment
        )
        originFormDocumentList[indexDocument] = formDocumentList

        if (formDocumentList.attachment.length <= 0) {
            if (formDocumentList.link_input) {
                if (formDocumentList.link_input.length <= 0) {

                    changeFieldValue(`${formDocumentList.type.replace(/\./g, ' ')}`, '')
                }
            }
        }

        this.setState({ formDocumentList: originFormDocumentList })

    }

    handleAttachmentUpload(e) {
        const { globalAddSweetAlertData, globalHideSweetAlert, translationjob } = this.props;

        let $this = this;
        const translation: Map<string, any> = fromJS(translationjob.translation)
        let files = e.target.files
        if (e.target.files[0].size > 1000000000) {
            return globalAddSweetAlertData({
                show: true,
                title: t(translation, 'FILE_SIZE_EXCEED_LANDING_PAGE'),
                text: t(translation, 'LONGER_TO_UPLOAD_PROCEED_LANDING_PAGE'),
                confirmButtonText: 'OK',
                confirmButtonColor: '#ED2453',
                cancelButtonText: t(translation, 'LABEL_CANCEL'),
                showCancelButton: true,
                customClass: 'swal-alert-mobile',
                showLoaderOnConfirm: true,
                onCancel: () => {

                    return globalHideSweetAlert()
                },
                onConfirm: () => {
                    //restore list
                    $this.uploadAttachments(files, $this.state.targetIndexUpload)
                    return globalHideSweetAlert()

                }
            })
        }

        this.uploadAttachments(e.target.files, this.state.targetIndexUpload)


        // processFile(e.target.files)
    }
    uploadAttachments(files, targetIndexDocument) {
        const {
            publicJobDetail,
            docAttachmentUpload,
            docAttachmentCV,
            docAttachment,
            documentAttachment,
            touchForm,
            stopAsyncValidationForm,
            changeFieldValue,
            globalAddSweetAlertData,
            globalHideSweetAlert,
            translationjob,
        } = this.props
        let company = publicJobDetail.company
        const translation: Map<string, any> = fromJS(translationjob.translation)
        // return processFile(files,company.id)

        let formDocumentList = this.state.formDocumentList[targetIndexDocument]
        let originFormDocumentList = this.state.formDocumentList




        if (formDocumentList.attachment) {

        } else {
            formDocumentList.attachment = []
        }

        const current_files = formDocumentList.attachment
        let outputFilesState = current_files
        let outputFiles = documentAttachment.file_attachment

        //checkDocumentName
        let checkSameFile = 0
        current_files.map((v, i) => {
            if (v.filename == files[0].name) {
                checkSameFile = 1
            }
        })
        if (checkSameFile) {
            return globalAddSweetAlertData({
                show: true,
                title: t(translation, 'DOCUMENT_EXIST_LANDING_PAGE'),
                html: true,
                text: t(translation, 'DOCUMENT_TRY_UPLOAD_ANOTHER_LANDING_PAGE'),
                confirmButtonText: 'Ok',
                confirmButtonColor: '#564FDB',
                onConfirm: () => {
                    globalHideSweetAlert()
                }
            })
        }

        let size_current_files = current_files.length;
        if (current_files.size > 0) {
            size_current_files = 0
            outputFiles.map((value) => {
                if (value.sizeUnit == 'KB') {
                    size_current_files += (value.sizeFile / 1000)
                } else {
                    size_current_files += value.sizeFile
                }

            })
        }

        let found_exceedSize = 0
        let found_invalidType = 0
        let $this = this
        let lastAttachmentIndex = this.state.lastAttachmentIndex
        Object.keys(files).map((index) => {
            let file_size = Math.round(files[index].size / 1028576)
            let file_unit_value = 'MB'
            let exceedSize = 0
            let invalidType = 0
            let cvTypeInvalid = 0

            if (!ACCEPTED_MULTI_DOC.includes(getFormatExtension(files[index].name.toLowerCase()))) {

                invalidType = 1

            }


            if (targetIndexDocument == 0) {
                if (!ACCEPTED_PDF_DOC.includes(files[index].type)) {

                    cvTypeInvalid = 1

                }
            }

            if (file_size < 1) {
                file_size = Math.round(files[index].size / 1028)
                file_unit_value = 'KB'
            }

            if (exceedSize) {

            } else {
                const dateMod = Date.now();
                let errMessage = ''
                let status = "loading"
                if (invalidType == 1) {
                    errMessage = t(translation, 'NOT_SUPPORTED_FILE_LANDING_PAGE')
                    status = "unsupported"
                }

                if (cvTypeInvalid == 1) {
                    errMessage = t(translation, 'LABEL_FILE_TYPE_MUST')
                    status = "unsupported"
                }

                outputFiles.push({
                    "filename": files[index].name,
                    "type": files[index].type,
                    "url": null, /** NULL for post, not NULL for unchange-put */
                    "filepath": "",
                    "status": status,
                    "showBarProgress": 1,
                    "progress": "",
                    "sizeFile": file_size,
                    "sizeUnit": file_unit_value,
                    "progressFile": 0,
                    "originalFile": files[index],
                    "lastModified": dateMod,
                    "identifier": lastAttachmentIndex,
                    "tokenCancel": "",
                    "startSize": 0,
                    "endSize": 0,
                    'created_date_form': dateMod,
                    'errorMessage': '',
                });
                outputFilesState.push({
                    "filename": files[index].name,
                    "type": files[index].type,
                    "url": null, /** NULL for post, not NULL for unchange-put */
                    "filepath": "",
                    "status": status,
                    "showBarProgress": 1,
                    "progress": "",
                    "sizeFile": file_size,
                    "sizeUnit": file_unit_value,
                    "progressFile": 0,
                    "originalFile": files[index],
                    "lastModified": dateMod,
                    "identifier": lastAttachmentIndex,
                    "tokenCancel": "",
                    "startSize": 0,
                    "endSize": 0,
                    "pollingFunc": 0,
                    "errorMessage": errMessage,
                    'created_date_form': dateMod,
                    'type': 'attachment',

                })
                files[index].identifier = lastAttachmentIndex
                docAttachment(outputFiles)
                    .then(() => {
                        if (invalidType == 1 || cvTypeInvalid == 1) {
                            return;
                        }
                        // $this.setState({templateIsChanged:1})
                        let obj = null
                        let obj_index = -1
                        outputFiles.map((_r, _i) => {
                            if (_r.identifier == files[index].identifier) {
                                obj = _r
                                obj_index = _i
                            }
                        })

                        formDocumentList.attachment = outputFilesState
                        originFormDocumentList[targetIndexDocument] = formDocumentList
                        this.setState({ formDocumentList: originFormDocumentList }, () => {
                            if (file_unit_value == 'MB') {
                                let indexAttachment = 0;
                                outputFilesState.map((value, index) => {
                                    if (value.identifier == lastAttachmentIndex) {
                                        indexAttachment = index
                                    }
                                })
                                // lastAttachmentIndex adalah identifier 
                                // Use docAttachmentCV for CV uploads (targetIndexDocument == 0)
                                if (targetIndexDocument == 0) {
                                    docAttachmentCV(company.id, files[index], obj_index, targetIndexDocument, dateMod)
                                } else {
                                    this.processFile(files[index], company.id, obj_index, targetIndexDocument, indexAttachment, null, 1)
                                }
                            } else {
                                // Use docAttachmentCV for CV uploads (targetIndexDocument == 0)
                                if (targetIndexDocument == 0) {
                                    docAttachmentCV(company.id, files[index], obj_index, targetIndexDocument, dateMod)
                                } else {
                                    docAttachmentUpload(company.id, files[index], obj_index, targetIndexDocument, dateMod)
                                }
                            }
                        })

                    })

                changeFieldValue(`${formDocumentList.type.replace(/\./g, ' ')}`, 'changes')

                lastAttachmentIndex++;
                this.setState({ lastAttachmentIndex })

            }
        })

    }

    checkLinkErrorValue(objectDocument, ind, objectInput) {
        const { translationjob } = this.props
        const translation: Map<string, any> = fromJS(translationjob.translation)

        let every_link = objectDocument.link_input
        if (objectInput.change == 1) {
            let message = ''

            if (objectInput.linkErrorMessage) {
                message = objectInput.linkErrorMessage
            }

            if (!regexLinkCheck(objectInput.value)) {
                message = t(translation, 'INVALID_URL_LANDING_PAGE')
            }

            if (objectInput.value.trim() == '') {
                message = t(translation, 'LINK_CANT_BE_BLANK_LANDING_PAGE')
            }

            every_link = every_link.filter((val, idx) => idx != ind)

            every_link.map((val, idx) => {
                if (objectInput.value == val.value) {
                    message = t(translation, 'LINK_CANT_BE_SAME_LANDING_PAGE')
                }
            })



            //link check api

            return message

        }
    }

    checkCanAddFieldLink(index) {
        let arrayValues = this.state.formDocumentList[index]
        let result = true
        if (arrayValues.link_input) {
            arrayValues.link_input.map((res, index) => {
                if (res.value.trim() == '') {
                    result = false
                }
            })

            return result
        }
        return result

    }

    handleFieldLinkChange(e, idxCont, idxField) {
        const { changeFieldValue, translationjob } = this.props;
        const translation: Map<string, any> = fromJS(translationjob.translation)
        if (timeOutCheckLink) {
            clearTimeout(timeOutCheckLink);
        }
        let $this = this

        const text = e.target.value
        let formDocumentList = this.state.formDocumentList

        changeFieldValue(`${formDocumentList[idxCont].type.replace(/\./g, ' ')}`, text)

        timeOutCheckLink = setTimeout(() => {
            if (formDocumentList[idxCont].link_input[idxField]) {
                formDocumentList[idxCont].link_input[idxField].linkErrorMessage = t(translation, 'CHECKING_URL_LANDING_PAGE')
                $this.setState(formDocumentList);
            }

            checkLink(text).then((res) => {
                let data = res.data;
                let host = data.host;
                let malicious = data.result.malicious
                let suspicious = data.result.suspicious
                let status_code = data.status_code
                let error = 0;
                if (!formDocumentList[idxCont].link_input[idxField]) {
                    return
                }
                formDocumentList[idxCont].link_input[idxField].linkErrorMessage = ``
                if (status_code != 200) {
                    formDocumentList[idxCont].link_input[idxField].linkErrorMessage = t(translation, 'URL_CANT_BE_ACCESSED_LANDING_PAGE')
                    error = 1;
                }
                if (malicious > 0) {
                    formDocumentList[idxCont].link_input[idxField].linkErrorMessage = t(translation, 'URL_MALICIOUS_LANDING_PAGE')
                    error = 1;
                }
                if (suspicious > 0) {
                    formDocumentList[idxCont].link_input[idxField].linkErrorMessage = t(translation, 'URL_SUSPICIOUS_LANDING_PAGE')
                    error = 1;
                }

                formDocumentList[idxCont].link_input[idxField].domain_host = host
                if (error == 1) {

                    return $this.setState(formDocumentList);
                }

                if (GDDRIVE_DOMAIN.includes(host)) {
                    formDocumentList[idxCont].link_input[idxField].linkErrorMessage = t(translation, 'CHECKING_URL_LANDING_PAGE')
                    $this.setState(formDocumentList)
                    const id = "id" + Math.random().toString(16).slice(2)
                    return downloadAndCheckGdrive(text, id).then((res) => {
                        if (!formDocumentList[idxCont].link_input[idxField]) {
                            return
                        }
                        const data = res.data
                        if (data.message) {
                            formDocumentList[idxCont].link_input[idxField].linkErrorMessage = t(translation, 'URL_NOT_HAVE_PERMISSION')
                            $this.setState(formDocumentList)
                        }
                        if (data.link_download) {
                            formDocumentList[idxCont].link_input[idxField].linkErrorMessage = ''
                            formDocumentList[idxCont].link_input[idxField].id_file = id
                            formDocumentList[idxCont].link_input[idxField].download_path = data.link_download
                            $this.setState(formDocumentList)
                        }
                    })
                        .catch((e) => {
                            formDocumentList[idxCont].link_input[idxField].linkErrorMessage = t(translation, 'URL_NOT_HAVE_PERMISSION')
                            $this.setState(formDocumentList)
                        })
                } else if (YT_DOMAIN.includes(host)) {
                    formDocumentList[idxCont].link_input[idxField].linkErrorMessage = t(translation, 'CHECKING_URL_LANDING_PAGE')
                    $this.setState(formDocumentList)
                    const id = "id" + Math.random().toString(16).slice(2)
                    return downloadAndCheckYoutube(text, id).then((res) => {
                        if (!formDocumentList[idxCont].link_input[idxField]) {
                            return
                        }
                        const data = res.data
                        if (data.path_link) {
                            formDocumentList[idxCont].link_input[idxField].linkErrorMessage = ''
                            formDocumentList[idxCont].link_input[idxField].id_file = id
                            formDocumentList[idxCont].link_input[idxField].download_path = data.path_link
                            $this.setState(formDocumentList)
                        } else {
                            formDocumentList[idxCont].link_input[idxField].linkErrorMessage = t(translation, 'URL_NOT_HAVE_PERMISSION')
                            $this.setState(formDocumentList)
                        }
                    })
                        .catch((e) => {
                            formDocumentList[idxCont].link_input[idxField].linkErrorMessage = t(translation, 'URL_NOT_HAVE_PERMISSION')
                            $this.setState(formDocumentList)
                        })
                } else {
                    formDocumentList[idxCont].link_input[idxField].linkErrorMessage = t(translation, 'CHECKING_URL_LANDING_PAGE')
                    $this.setState(formDocumentList)
                    const id = "id" + Math.random().toString(16).slice(2)
                    return downloadAndCapturePages(text, id).then((res) => {
                        if (!formDocumentList[idxCont].link_input[idxField]) {
                            return
                        }
                        if (res.data) {
                            if (res.data.data) {
                                const { data } = res.data
                                formDocumentList[idxCont].link_input[idxField].linkErrorMessage = ''
                                formDocumentList[idxCont].link_input[idxField].id_file = id
                                formDocumentList[idxCont].link_input[idxField].download_path = data.link_capture_path
                                $this.setState(formDocumentList)
                            }
                        } else {
                            formDocumentList[idxCont].link_input[idxField].linkErrorMessage = 'URL can not be processed. Please input accessible URL.'
                            $this.setState(formDocumentList)
                        }
                    })
                }





            })
                .catch((error) => {
                    if (!formDocumentList[idxCont].link_input[idxField]) {
                        return
                    }
                    formDocumentList[idxCont].link_input[idxField].linkErrorMessage = ''
                    $this.setState(formDocumentList);
                })
        }, 500);

        formDocumentList[idxCont].link_input[idxField].value = text
        formDocumentList[idxCont].link_input[idxField].change = 1
        this.setState(formDocumentList);
    }

    handleRemoveInputLink(e, idxCont, idxField, label) {
        const { changeFieldValue } = this.props
        let formDocumentList = this.state.formDocumentList
        let link_input = this.state.formDocumentList[idxCont].link_input

        link_input = link_input.filter((val, index) => index != idxField)

        formDocumentList[idxCont].link_input = link_input

        if (formDocumentList[idxCont].link_input.length <= 0) {
            if (formDocumentList[idxCont].attachment) {
                if (formDocumentList[idxCont].attachment.length <= 0) {
                    changeFieldValue(`${label.replace(/\./g, ' ')}`, '')
                }
            } else {
                changeFieldValue(`${label.replace(/\./g, ' ')}`, '')
            }

        }
        this.setState(formDocumentList);
    }

    addLinkInputerForm(e, index, label) {
        const { changeFieldValue } = this.props
        const date = Date.now();
        if (this.checkCanAddFieldLink(index)) {
            let formDocumentList = this.state.formDocumentList
            if (formDocumentList[index].link_input) {
                formDocumentList[index].link_input.push({ value: '', change: 0, created_date_form: date, type: 'link' })
            } else {
                formDocumentList[index].link_input = []
                formDocumentList[index].link_input.push({ value: '', change: 0, created_date_form: date, type: 'link' })
            }
            changeFieldValue(`${label.replace(/\./g, ' ')}`, 'changes')
            this.setState({ formDocumentList })
        }

    }

    dragEnter(e) {
        e.preventDefault();
        e.stopPropagation();
    }
    dragOver(e) {
        e.preventDefault();
        e.stopPropagation();
    }


    renderCVupload(getLabel) {
        const {
            documentAttachment,
            translationjob,
        } = this.props
        const translation: Map<string, any> = fromJS(translationjob.translation)
        const fileAttachmentReducer = documentAttachment.file_attachment
        const formDocumentList = this.state.formDocumentList
        const returnRender = []
        if (formDocumentList.length) {
            const formDocument = formDocumentList[0]

            if (formDocument.option_value < 1) {
                return
            }

            let label = `${formDocument.type}`
            if (formDocument.option_value == 1) {
                label = `${formDocument.type} (${t(translation, 'LABEL_OPTIONAL')})`
            }


            if (getLabel) {
                return label
            }

            let uploaded = false
            let file_uploader = []

            returnRender.push(
                <div className="upload-drop-container">
                    <span onDragOver={this.dragOver} onDragEnter={this.dragEnter} onDrop={(e) => {
                        e.preventDefault()
                        e.stopPropagation();
                        const files = e.dataTransfer.files
                        this.setState({ targetIndexUpload: 0 }, () => {
                            if (!uploaded) {

                                this.uploadAttachments(files, 0)
                            }
                        })
                    }} className={`rc-upload wrapper-dropzone-doc`}>
                        <input
                            name="introduction_video"
                            className="form-control hide"
                            id="introduction-video"
                            type="file"
                        />
                        <input
                            name="introduction_video_height"
                            id="introduction-video-height"
                            type="hidden"
                        />
                        <input
                            name="introduction_video_width"
                            id="introduction-video-width"
                            type="hidden"
                        />
                        <div className="">
                            <h4>{t(translation, 'LABEL_UPLOAD_CV_RESUME')}</h4>
                            <p>{t(translation, 'LABEL_PLEASE_DRAG_DROP')}</p>

                            <button type='button' className="button-upload"
                                onClick={() => {
                                    this.setState({ targetIndexUpload: 0 }, () => {
                                        if (!uploaded) {
                                            this.uploadRef.current.click();
                                        }
                                    })
                                }}
                            >
                                <i className="icon-i-up-doc"></i>{t(translation, 'LABEL_SELECT_FILE')}
                            </button>

                        </div>
                    </span>
                    <p className="m-t-8 p-type">{t(translation, 'LABEL_UPLOAD_CV_IN')}</p>
                    <Field name={label} component={this.renderErrorNoTranslation} />
                </div>

            )

            if (formDocument.attachment) {
                if (formDocument.attachment.length > 0) {
                    uploaded = 1
                }
                const attachment = formDocument.attachment
                let fileCondition = 0
                let messageError = ''
                let idxRemove = null

                attachment.map((rs, idx) => {
                    const objectNya = fileAttachmentReducer.filter((v, i) => v.identifier == rs.identifier)
                    if (objectNya[0].status == 'finish' && objectNya[0].showBarProgress == 0) {
                        fileCondition = 1
                    }
                    if (objectNya[0].showBarProgress == 1) {
                        if (objectNya[0].status == 'loading' || objectNya[0].status == 'finish') {
                            fileCondition = 2
                        } else {
                            fileCondition = 0
                        }


                    }

                    messageError = this.renderErrorFileState(rs.errorMessage)
                    if (objectNya[0].errorMessage) {
                        messageError = this.renderErrorFileState(objectNya[0].errorMessage)
                    }
                    idxRemove = idx
                    file_uploader.push(
                        <Fragment>
                            <FileUploader translation={translation} handleCancelUpload={(e) => { this.handleCancelUpload(e, rs.identifier, 0, idx) }} handleReuploadFile={(e) => { this.handleReuploadFile(e, rs.identifier, 0, idx) }} handleRemoveFile={(e) => { this.handleRemoveFile(e, 0, idx) }} key={idx} data_file={objectNya[0]} />
                            {this.renderErrorFileState(rs.errorMessage)}
                        </Fragment>
                    )
                })

                if (fileCondition == 1) {


                    return (
                        <div className='div-multidoc-action'>


                            <div className='horizontal-item--between m-b-8'>

                                <div className='div-action-icon'>
                                    <i data-toggle="tooltip" data-placement="top" title={`${t(translation, 'ADD_LINK_LANDING_FORM')}`} className='icon-i-add-link hide'></i>
                                    <i data-toggle="tooltip" data-placement="top" title={`${t(translation, 'ADD_DOCUMENT_LANDING_FORM')}`} onClick={(e) => {
                                        this.setState({ targetIndexUpload: 0 }, () => {
                                            if (!uploaded) {
                                                this.uploadRef.current.click();
                                            }
                                        })

                                    }} className={`icon-i-add-file m-l-8 ${uploaded ? 'hide' : ''}`}></i>

                                </div>
                            </div>
                            {file_uploader}
                            <Field name={label} component={this.renderErrorNoTranslation} />
                        </div>
                    )


                } else {
                    return (
                        <div className="upload-drop-container">
                            <span onDragOver={this.dragOver} onDragEnter={this.dragEnter} onDrop={
                                (e) => {
                                    e.preventDefault()
                                    e.stopPropagation();
                                    const files = e.dataTransfer.files
                                    this.setState({ targetIndexUpload: 0 }, () => {

                                        this.handleRemoveFile(e, 0, idxRemove)
                                        this.uploadAttachments(files, 0)

                                    })
                                }
                            } className={`rc-upload wrapper-dropzone-doc ${fileCondition == 2 && 'processing'}`}>
                                <input
                                    name="introduction_video"
                                    className="form-control hide"
                                    id="introduction-video"
                                    type="file"
                                />
                                <input
                                    name="introduction_video_height"
                                    id="introduction-video-height"
                                    type="hidden"
                                />
                                <input
                                    name="introduction_video_width"
                                    id="introduction-video-width"
                                    type="hidden"
                                />
                                <div className="">
                                    <h4>{t(translation, 'LABEL_UPLOAD_CV_RESUME')}</h4>
                                    <p>{t(translation, 'LABEL_PLEASE_DRAG_DROP')}</p>
                                    {fileCondition == 2 ?
                                        <p><i className="fa fa-spinner fa-spin"></i>{t(translation, 'LABEL_PROCESSING')}</p>
                                        :
                                        ''
                                    }

                                    <button type='button' className="button-upload"
                                        onClick={(e) => {
                                            this.setState({ targetIndexUpload: 0 }, () => {

                                                this.handleRemoveFile(e, 0, idxRemove)
                                                this.uploadRef.current.click();

                                            })
                                        }}
                                    >
                                        <i className="icon-i-up-doc"></i>{t(translation, 'LABEL_SELECT_FILE')}
                                    </button>

                                </div>
                            </span>
                            <p className="m-t-8 p-type">{t(translation, 'LABEL_UPLOAD_CV_IN')}</p>
                            {messageError}
                            <Field name={label} component={this.renderErrorNoTranslation} />
                        </div>

                    )
                }


            }


        }

        return returnRender;
    }

    renderMultiDocForm() {
        const {
            documentAttachment,
            translationjob,
        } = this.props
        const translation: Map<string, any> = fromJS(translationjob.translation)
        const fileAttachmentReducer = documentAttachment.file_attachment
        const formDocumentList = this.state.formDocumentList
        let documentFormList = []
        formDocumentList.map((value, index) => {
            if (value.option_value > 0) {
                if (index == 0) {
                    let label = `${value.type}`
                    if (value.option_value == 1) {
                        label = `${value.type} (Optional)`
                    }
                    let uploaded = false
                    let file_uploader = []
                    if (value.attachment) {
                        if (value.attachment.length > 0) {
                            uploaded = 1
                        }
                        const attachment = value.attachment
                        attachment.map((rs, idx) => {
                            const objectNya = fileAttachmentReducer.filter((v, i) => v.identifier == rs.identifier)
                            file_uploader.push(
                                <Fragment>
                                    <FileUploader translation={translation} handleCancelUpload={(e) => { this.handleCancelUpload(e, rs.identifier, index, idx) }} handleReuploadFile={(e) => { this.handleReuploadFile(e, rs.identifier, index, idx) }} handleRemoveFile={(e) => { this.handleRemoveFile(e, index, idx) }} key={idx} data_file={objectNya[0]} />
                                    {this.renderErrorFileState(rs.errorMessage)}
                                </Fragment>
                            )
                        })
                    }


                    documentFormList.push(
                        <div className='div-multidoc-action hide'>


                            <div className='horizontal-item--between m-b-8 '>
                                <label>{label}</label>
                                <div className='div-action-icon'>
                                    <i data-toggle="tooltip" data-placement="top" title={`${t(translation, 'ADD_LINK_LANDING_FORM')}`} className='icon-i-add-link hide'></i>
                                    <i data-toggle="tooltip" data-placement="top" title={`${t(translation, 'ADD_DOCUMENT_LANDING_FORM')}`} onClick={(e) => {
                                        this.setState({ targetIndexUpload: index }, () => {
                                            if (!uploaded) {
                                                this.uploadRef.current.click();
                                            }
                                        })

                                    }} className={`icon-i-add-file m-l-8 ${uploaded ? 'disabled' : ''}`}></i>

                                </div>
                            </div>
                            {file_uploader}
                            <Field name={label} component={this.renderErrorNoTranslation} />
                        </div>
                    )
                } else {

                    let label = `${value.type}`
                    if (value.option_value == 1) {
                        label = `${value.type} (${t(translation, 'LABEL_OPTIONAL')})`
                    }
                    let inputLink = []

                    let file_uploader = []
                    let render_array = []
                    let combinedArray = [];
                    if (value.attachment) {
                        combinedArray = combinedArray.concat(value.attachment);
                    }

                    if (value.link_input) {
                        combinedArray = combinedArray.concat(value.link_input);
                    }

                    combinedArray.sort((a, b) => new Date(a.created_date_form) - new Date(b.created_date_form));
                    combinedArray.map((item, index_combined) => {

                        if ('identifier' in item) {
                            // const attachment = item
                            let idx = 0;
                            const filtered_attachment = value.attachment.filter((a) => a == item)
                            value.attachment.map((a, idx_filter) => {
                                if (a == item) {
                                    idx = idx_filter;
                                }
                            })

                            filtered_attachment.map((rs) => {
                                const objectNya = fileAttachmentReducer.filter((v, i) => v.identifier == rs.identifier)
                                render_array.push(
                                    <Fragment>
                                        <FileUploader translation={translation} handleCancelUpload={(e) => { this.handleCancelUpload(e, rs.identifier, index, idx) }} handleReuploadFile={(e) => { this.handleReuploadFile(e, rs.identifier, index, idx) }} handleRemoveFile={(e) => { this.handleRemoveFile(e, index, idx) }} key={idx} data_file={objectNya[0]} />
                                        {this.renderErrorFileState(rs.errorMessage)}
                                    </Fragment>
                                )
                            })
                        }

                        if (item.type == 'link') {
                            let ind = 0;
                            const link_input = value.link_input.filter((a) => a == item)

                            value.link_input.map((a, idx_filter) => {
                                if (a == item) {
                                    ind = idx_filter;
                                }
                            })

                            link_input.map((res) => {
                                if (res) {
                                    render_array.push(
                                        <Fragment>
                                            <LinkInputer translation={translation} handleOnChangeText={(e) => this.handleFieldLinkChange(e, index, ind)} value={res.value} handleDelete={(e) => { this.handleRemoveInputLink(e, index, ind, label) }} />
                                            <ul className={`error ${this.checkLinkErrorValue(value, ind, res) ? '' : 'hide'}`}><li style={{ listStyle: "disc", marginLeft: "15px" }}><span className="error">{this.checkLinkErrorValue(value, ind, res)}</span></li></ul>
                                        </Fragment>
                                    )
                                }

                            })
                        }
                    })


                    documentFormList.push(
                        <div className='div-multidoc-action'>
                            <div className='horizontal-item--between m-b-8'>
                                <label>{label}</label>
                                <div className='div-action-icon'>
                                    <i data-toggle="tooltip" data-placement="top" title={`${t(translation, 'ADD_LINK_LANDING_FORM')}`} onClick={(e) => this.addLinkInputerForm(e, index, label)} className={`icon-i-add-link ${this.checkCanAddFieldLink(index) ? '' : 'disabled'}`}></i>

                                    <i data-toggle="tooltip" data-placement="top" title={`${t(translation, 'ADD_DOCUMENT_LANDING_FORM')}`} onClick={(e) => {
                                        this.setState({ targetIndexUpload: index }, () => {
                                            this.uploadRef.current.click();
                                        })
                                    }} className='icon-i-add-file m-l-8'></i>

                                </div>
                            </div>
                            {render_array.reverse()}

                            <Field name={label.replace(/\./g, ' ')} component={this.renderErrorNoTranslation} />
                        </div>
                    )
                }

            }
        })

        return documentFormList

    }

    countWord(value) {

        if (value) {
            let countText;
            if (value.trim().length == 0) {
                countText = 0;
            } else {
                countText = value == "" ? 0 : value.match(/\S+/g).length;
            }
            return countText
        } else {
            return 0
        }


    }


    handlePopUp(value) {
        const { publicJobDetail } = this.props
        const company = publicJobDetail.company || {}
        const job = publicJobDetail.job || {}

        const parser: Object = new UAParser();
        const isMobile: boolean = parser.getDevice().type === 'mobile'

        var thisPageURL = window.location.href
        var url = ''
        if (value == 'facebook') {
            url = 'https://www.facebook.com/sharer/sharer.php?&u=' + thisPageURL
            // 'http://www.facebook.com/dialog/feed?'+
            //	'app_id='+thisPageURL
            // 			'link='+thisPageURL+
            // 			'message=Join us. Click here: '+thisPageURL
        }
        if (value == 'Whatsapp' && isMobile) {
            url = 'https://api.whatsapp.com/send?text=Join us. Click here: ' + thisPageURL
        } else if (value == 'Whatsapp') {
            url = 'https://web.whatsapp.com/send?text=Join us. Click here: ' + thisPageURL
        }
        if (value == 'linkedin') {
            url = 'https://www.linkedin.com/sharing/share-offsite/?url=' + thisPageURL
        }
        if (value == 'twitter') {
            url = 'https://twitter.com/intent/tweet?url=' + thisPageURL + '&text=Join us. Click here: '
        }
        if (value == 'email') {
            url = 'mailto:?subject=Apply Now: ' + job.title + ' at ' + company.title + '&body=Join us. Click here: ' + thisPageURL
        }
        window.open(url, 'popUpWindow', 'height=600,width=600,left=400,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes')
    }
    inputFocus(e: object): void {
        const { publicJobDetail, publicJobCustom } = this.props

        const company = publicJobDetail.company || {}
        const fontColor = company.font_color
        let customColor = publicJobCustom.color
        customColor = company.brand_color || customColor

        const colorCondition = fontColor == '#000000' ? fontColor : customColor

        e.target.style.boxShadow = `0 0 10px ${colorCondition}`;
        e.target.style.border = `1px solid ${colorCondition}`;
        e.target.style.borderRadius = `5px`;
    }

    inputBlur(e: object): void {
        e.target.style.border = `1px solid #999999`
        e.target.style.borderRadius = ``
        e.target.style.boxShadow = ``
    }

    handleChangeTextArea(e) {
        const { changeFieldValue } = this.props
        const wordCount =
            e.target.value === "" || e.target.value.match(/\S+/g) == null
                ? 0
                : e.target.value.match(/\S+/g).length;
        if (wordCount > 1000) {

        } else {
            changeFieldValue('experience', e.target.value)
        }
    }

    resizeTextArea(e, addInfoId) {
        this.removeErrorMessage(addInfoId)
        var text = e.target

        var x = window.scrollX,
            y = window.scrollY;
        text.style.height = "auto";
        text.style.height = text.scrollHeight + "px";
        text.style.overflowY = "hidden";
        text.scrollTop = text.scrollHeight;
        text.focus();
        window.scrollTo(x, y);
    }

    removeErrorMessage(addInfoId) {
        var elm = document.getElementById('js-is-error-mandatory-' + addInfoId)
        if (elm) {
            elm.innerHTML = ''
        }
    }

    handleFileSave(e) {
        const { formValues,
            changeFieldValue,
            registrationSaveDataError } = this.props
        const data = new FormData();
        const file = e.target.files[0]

        if (typeof file != 'undefined') {
            if (file.size > 5000000) {
                registrationSaveDataError(
                    { file: ["file type cannot more than 5 MB."] }
                )
                this.setState({ cvName: '' })
            } else {
                registrationSaveDataError({})
                this.setState({ uploadProgress: 'up' })
                data.append("file", file || []);
                data.append("type", "cv" || []);
                _axios({
                    url: `/upload-cv`,
                    timeout: 200000,
                    method: 'post',
                    data,
                    onUploadProgress: progressEvent => {
                        this.setState({ cvName: file.name })
                        const uploadPercentage = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        this.setState({ uploadFilePercentage: uploadPercentage })


                        // dispatch({
                        //   type: "INTERVIEWS_ADD_UI_UPLOAD_VIDEO_PERCENTAGE_SUCCESS",
                        //   upload_video_percentage: uploadVideoPercentage
                        // });
                    }
                })
                    .then((data) => {
                        registrationSaveDataError({})
                        const fileresponse = data.data.file_name
                        const filename = fileresponse.substring(fileresponse.lastIndexOf('/') + 1);
                        changeFieldValue('cv', fileresponse)
                        this.setState({ file: filename })
                        this.setState({ uploadProgress: 'done' })
                    })
                    .catch((error) => {
                        changeFieldValue('cv', '')
                        this.setState({ file: '' })
                        registrationSaveDataError(error.response.data.message)
                        this.setState({ uploadProgress: '' })
                    })

            }
        }



    }

    handleConsentClick(e) {

        if (e.target.name == 'gdpr') {
            this.setState({ isConsent: !this.state.isConsent })
        }
        if (e.target.name == 'compliance') {
            this.setState({ isCompliance: !this.state.isCompliance })
        }

    }

    handleWhatsappReminderClick(e) {

        this.setState({ isWhatsappReminder: !this.state.isWhatsappReminder })
        this.props.changeFieldValue('whatsapp_notification', this.state.isWhatsappReminder)

    }


    componentDidMount() {
        const { openCode, publicTalentPoolGetDetailCode, documentAttachment } = this.props
        $('[data-toggle=tooltip]').tooltip()

        publicTalentPoolGetDetailCode(openCode).then((publicJobDetail) => {
            const _job = publicJobDetail.job
            const googleJobIDs = publicJobDetail.google_job_ids
            const company = publicJobDetail.company
            if(Array.isArray(googleJobIDs) && googleJobIDs.includes((_job.id).toString())){
                const script = document.createElement("script");
                script.type = "application/ld+json";
                let RichText = {
                    "@context": "https://schema.org/",
                    "@type": "JobPosting",
                    "title": _job.title,
                    "description": _job.aboutDescription,
                    "datePosted": _job.updated_at,
                    "validThrough": "2025-03-25 09:20:00",
                    "hiringOrganization": {
                        "@type": "Organization",
                        "name": publicJobDetail.company.title,
                        "sameAs": publicJobDetail.company.website,
                        "logo": publicJobDetail.company.logoUrl
                    },
                    "jobLocation": {
                        "@type": "Place",
                        "address": {
                            "@type": "PostalAddress",
                            "addressLocality": company.city,
                            "addressCountry": "Indonesia",
                            "addressRegion": company.city,
                            "streetAddress": company.city
                        }
                    },
                    "industry": "Information Technology and Services",
                    "employmentType": "FULL TIME"
                }
                script.text = JSON.stringify(RichText);
                document.body.appendChild(script);
            }
            if (_job.document_list) {
                this.setState({ formDocumentList: JSON.parse('[{\"type\": \"CV/Resume\", \"option_value\": 1}]') })
                // notes 0 not required or off ,1 optional ,2 required

            }
            if (publicJobDetail.additionalField) {
                let tempAdditionalFields = publicJobDetail.additionalField.map((data, index) => {
                    data.value = null
                    return data
                })
                this.setState({ tempAdditionalFields: tempAdditionalFields })
            }

        })

        // const company = JSON.parse(document.querySelector('#js-public-index-component').dataset.company)

        var timesRun = 0

        this.setState({ name: '', email: '', code: '' })

        var interval = setInterval(() => {
            timesRun += 1;
            if (timesRun === 100) {
                clearInterval(interval);
            }

            $('li').each(function () {
                var $this = $(this);
                if ($this.attr('style')) {
                    // $this.parent().addClass("class-new");
                } else {
                    $this.attr("style", "list-style-position:outside")
                }
            });

            // $('.rh5v-Overlay_inner').css('background-color', this.props.publicJobCustom.color)
        }, 100);

        window.onbeforeunload = function () { return true; }
    }

    componentDidUpdate(prevProps) {
        $('[data-toggle=tooltip]').tooltip()
    }

    checkExperience(value) {
        this.setState({ experience: value })
    }

    handleFileUpload(e) {
        e.preventDefault()

        const file = e.target.files[0]

        this.setState({ file })
    }

    removeRegexCharacter(str) {
        return str.replace(/[^0-9]/g, '')
    }

    removeSpaceCharacter(str) {
        if (str) {
            return str.replace(/\s/g, '')
        }
        return
    }

    imageOnError() {
        const {
            publicJobDetail,
            publicJobGetDetailAsync
        } = this.props

        publicJobDetail.company.logoUrl = imgDefaultLogo
        
        publicJobGetDetailAsync(publicJobDetail)
    }
    handleClickAfterSave() {
        const { documentAttachment, translationjob, submitting, pristine, invalid } = this.props
        const translation: Map<string, any> = fromJS(translationjob.translation)
        let $this = this
        let not_success = 0;
        const fileAttachmentReducer = documentAttachment.file_attachment
        const formDocumentList = this.state.formDocumentList
        let identifier_array = []
        // fileAttachmentReducer.map((value,index)=>{
        // 	if (value.status != 'success') {
        // 		identifier_array.push(value.identifier)
        // 	}
        // })
        const __updatedValuDocumentList = formDocumentList.map((doc, index) => {

            let attachment = doc.attachment

            if (attachment) {
                let updated_attachment = attachment.map((value, idx) => {
                    let identifier = value.identifier
                    // identifier_array(value.identifier)
                    fileAttachmentReducer.map((redvAL, idex) => {
                        if (identifier == redvAL.identifier) {
                            value = redvAL
                            if (redvAL.status !== 'finish') {
                                not_success = 1
                                value = redvAL
                                value.errorMessage = t(translation, 'RETRY_OR_DELETE_LANDING_PAGE')
                            } else {
                                value.tokenCancel = ''
                                value.originalFile = ''
                            }


                        }
                    })

                    return value
                })
                doc.attachment = updated_attachment
                return doc
            }
            return doc

        })


        const new__updatedValuDocumentList = __updatedValuDocumentList.map((doc, index) => {

            let link_input = doc.link_input

            if (link_input) {
                let updated_link_input = link_input.map((res, idx) => {

                    // identifier_array(value.identifier)
                    res.change = 1
                    const result = $this.checkLinkErrorValue(doc, idx, res)
                    if (result != '') {
                        not_success = 1
                    }
                    return res
                })
                doc.link_input = updated_link_input

                return doc
            }
            return doc

        })

        this.setState({ formDocumentList: new__updatedValuDocumentList })



        if (not_success == 1) {

            return
        }

        if (this.state.isSaved || this.state.error_exist) {
            var form = $("#form-registration").serializeArray();
            var returnArray = {};
            for (var i = 0; i < form.length; i++) {
                returnArray[form[i]['name']] = form[i]['value'];
            }

            if (invalid) {
                return
            } else {
                $('#btn-submit').prop('disabled', true)
                this.handleSaveData(returnArray)
            }

        }
    }
    handleSaveData(values) {		
        const {
            registrationTalentPoolSaveDataCode,
            publicJobDetail,
            translationjob,
            openCode,
            globalHideSweetAlert,
            globalAddSweetAlertData,
            publicJobCustom,
            touchForm,
            stopAsyncValidationForm,
            formState,
            reset,
            documentAttachment,
            submitting,
            pristine,
            invalid,
        } = this.props
        const {
            file,
            experience
        } = this.state

        if (invalid) {
            return
        }
        let $this = this;
        var colorCustom = publicJobCustom.color
        const delay_start = publicJobDetail.job.delay_start
        const company = publicJobDetail.company || {}
        const job = publicJobDetail.job || {}
        const detailJob: Map<string, any> = fromJS({ detailInfo: translationjob })
        this.setState({ isSaved: true })
        this.setState({ error_exist: false })
        const translation: Map<string, any> = fromJS(translationjob.translation)
        // const company = JSON.parse(document.querySelector('#js-public-index-component').dataset.company)

        const fontColor = company.font_color
        const colorCondition = fontColor == '#000000' ? fontColor : colorCustom

        let not_success = 0;
        const fileAttachmentReducer = documentAttachment.file_attachment
        const formDocumentList = this.state.formDocumentList
        let identifier_array = []
        // fileAttachmentReducer.map((value,index)=>{
        // 	if (value.status != 'success') {
        // 		identifier_array.push(value.identifier)
        // 	}
        // })
        //check and clean the data
        const __updatedValuDocumentList = formDocumentList.map((doc, index) => {

            let attachment = doc.attachment

            if (attachment) {
                let updated_attachment = attachment.map((value, idx) => {
                    let identifier = value.identifier
                    // identifier_array(value.identifier)
                    fileAttachmentReducer.map((redvAL, idex) => {
                        if (identifier == redvAL.identifier) {
                            value = redvAL
                            if (redvAL.status !== 'finish') {
                                not_success = 1
                                value = redvAL
                                value.errorMessage = t(translation, 'PLS_WAIT_TILL_COMPLETE_LANDING_PAGE')
                            } else {
                                value.tokenCancel = ''
                                value.originalFile = ''
                            }


                        }
                    })

                    return value
                })
                doc.attachment = updated_attachment
                return doc
            }
            return doc

        })
        $this = this
        const new__updatedValuDocumentList = __updatedValuDocumentList.map((doc, index) => {

            let link_input = doc.link_input

            if (link_input) {
                let updated_link_input = link_input.map((res, idx) => {

                    // identifier_array(value.identifier)
                    res.change = 1
                    const result = $this.checkLinkErrorValue(doc, idx, res)
                    if (result != '') {
                        not_success = 1
                    }
                    return res
                })
                doc.link_input = updated_link_input

                return doc
            }
            return doc

        })



        this.setState({ formDocumentList: new__updatedValuDocumentList })


        if (not_success == 1) {
            return
        }


        return new Promise((resolve, reject) => {
            map(values, (data, callback) => {
                const phones = values.phone
                const emails = values.email
                const escapedPhoneValue = this.removeRegexCharacter(phones)
                const escapedEmailValue = this.removeSpaceCharacter(emails)
                values.document_candidate = __updatedValuDocumentList
                if (escapedPhoneValue) {
                    values.phone = escapedPhoneValue
                }
                if (escapedEmailValue) {
                    values.email = escapedEmailValue
                }
                
                // Fix undefined employment_history after error 422
                if (!values.employment_history) {
                    const { formValues } = this.props;
                    if (formValues && formValues.employment_history) {
                        values.employment_history = formValues.employment_history;
                    } else {
                        values.employment_history = [];
                    }
                }
                
                // Fix other field arrays that might be undefined after error
                if (!values.education_background) {
                    const { formValues } = this.props;
                    values.education_background = (formValues && formValues.education_background) || [];
                }
                if (!values.languages) {
                    const { formValues } = this.props;
                    values.languages = (formValues && formValues.languages) || [];
                }
                if (!values.certifications) {
                    const { formValues } = this.props;
                    values.certifications = (formValues && formValues.certifications) || [];
                }
                if (!values.key_achievements) {
                    const { formValues } = this.props;
                    values.key_achievements = (formValues && formValues.key_achievements) || [];
                }
                
                // Clean education_background data to ensure only gpa_score is sent, not gpa
                if (values.education_background && Array.isArray(values.education_background)) {
                    values.education_background = values.education_background.map(edu => {
                        const cleanedEdu = { ...edu };
                        
                        // Remove any legacy 'gpa' field if it exists
                        if (cleanedEdu.gpa) {
                            delete cleanedEdu.gpa;
                        }
                        
                        // Ensure gpa_score is properly set
                        if (cleanedEdu.gpa_score === undefined || cleanedEdu.gpa_score === '') {
                            cleanedEdu.gpa_score = '';
                        }
                        
                        return cleanedEdu;
                    });
                }
                
                // Clean employment_history data to ensure proper object structure
                if (values.employment_history && Array.isArray(values.employment_history)) {
                    values.employment_history = values.employment_history.map((emp, index) => {
                        // Check if employment history entry is a string (corrupted data)
                        if (typeof emp === 'string') {
                            // Convert string back to proper object structure
                            return {
                                company_name: '',
                                job_title: '',
                                job_family: '',
                                job_level: '',
                                start_date: '',
                                end_date: '',
                                is_current_job: false,
                                job_description: emp, // Put the string content as job_description
                                industry: ''
                            };
                        }
                        
                        // Ensure proper object structure for valid objects
                        return {
                            company_name: emp.company_name || '',
                            job_title: emp.job_title || '',
                            job_family: emp.job_family || '',
                            job_level: emp.job_level || '',
                            start_date: emp.start_date || '',
                            end_date: emp.end_date || '',
                            is_current_job: emp.is_current_job || false,
                            job_description: emp.job_description || '',
                            industry: emp.industry || ''
                        };
                    });
                }
                
                // Convert skills from comma-separated strings to arrays for backend (only if they're strings)
                if (values.soft_skills) {
                    if (typeof values.soft_skills === 'string') {
                        values.soft_skills = values.soft_skills.split(',').map(skill => skill.trim()).filter(skill => skill !== '');
                    }
                    // Ensure it's always an array for backend
                    if (!Array.isArray(values.soft_skills)) {
                        values.soft_skills = [];
                    }
                }
                
                if (values.hard_skills) {
                    if (typeof values.hard_skills === 'string') {
                        values.hard_skills = values.hard_skills.split(',').map(skill => skill.trim()).filter(skill => skill !== '');
                    }
                    // Ensure it's always an array for backend
                    if (!Array.isArray(values.hard_skills)) {
                        values.hard_skills = [];
                    }
                }
                
                callback(null, values)
            }, (error, results) => {
                let isErrorMandatory = false
                map(publicJobDetail.additionalField, (addinfo, callback) => {
                    let value = ''

                    if (addinfo.id === 77) {
                        value = experience
                    } else {
                        value = formState[`${snakeCase(addinfo.label)}-${addinfo.id}`] || []
                    }

                    let inputType = null
                    if (addinfo.input_type) {
                        inputType = addinfo.input_type
                    }
                    callback(null, { id: addinfo.id, value: value, is_mandatory: addinfo.is_mandatory, label: addinfo.label, input_type: inputType })

                }, (error, results) => {
                    values.custom_fields = results
                    values.file_cv = file

                    if (isErrorMandatory === false) {
                        // registrationSaveData(values, companySlug, jobSlugs)
                        registrationTalentPoolSaveDataCode(values, openCode)
                            .then((data) => {
                                this.setState({ name: values.fullname, email: values.email, code: data.interview_code, url: data.url })
                                
                                let description = t(
                                    translation,
                                    'MODAL_SUCCESS_REGISTER_MESSAGE',
                                    {
                                        ':candidate_fullname': values.fullname,
                                        ':candidate_interview_code': data.interview_code,
                                        ':candidate_email': values.email,
                                        ':company_name': company.title
                                    }
                                )
                                if (job.device_type == 2) {
                                    description = t(
                                        translation,
                                        'MODAL_MOBILE_ONLY_SUCCESS_REGISTER_MESSAGE',
                                        {
                                            ':candidate_fullname': values.fullname,
                                            ':code': data.interview_code,
                                            ':email': values.email
                                        }
                                    )
                                } else if (job.device_type == 1) {
                                    description = t(
                                        translation,
                                        'MODAL_DESKTOP_ONLY_SUCCESS_REGISTER_MESSAGE',
                                        {
                                            ':candidate_fullname': values.fullname,
                                            ':code': data.interview_code,
                                            ':email': values.email
                                        }
                                    )
                                }
                                
                                this.setState({ show_received_application: 1 })
                                


                                




                                // $('#registration-form').addClass("hide")
                                // $('#registration-form__success').removeClass("hide")
                                $('.js-job-detail-file').val('')

                                this.setState({ file: '' })

                                return Promise.resolve()
                            })
                            .catch((error) => {
                                this.setState({ isSaved: false })
                                if (typeof error.response == "undefined") {
                                    // TODO
                                } else if (error.response.data.message == 'Our system is detecting that you have already applied to this job. You cannot apply twice. Please contact help@astrnt.co if you think there is an error') {
                                    // dispatch(registrationSaveDataError(error.response.data))
                                    touchForm(['email'])
                                    stopAsyncValidationForm({ email: 'ERROR_EMAIL_REGISTERED' })
                                    this.setState({ error_exist: true })
                                } else if (error.response.data.message == 'Phone number already registered') {
                                    // TODO
                                    touchForm(['phone'])
                                    stopAsyncValidationForm({ phone: 'ERROR_MOBILE_NUMBER_REGISTERED' })
                                    this.setState({ error_exist: true })
                                } else {

                                }
                                // reject(error)
                            })
                    } else {
                        reject()
                    }
                })
            })
        })
    }

    renderErrorNoTranslation({ meta: { touched, error } }) {
        const {
            translationjob
        } = this.props
        const translations: Map<string, any> = fromJS(translationjob.translation)
        let messageError = error
        if (error) {
            const parts = error.match(/REQUIRED_LANDING_PAGE/);
            if (parts) {

                messageError = `${error.replace("REQUIRED_LANDING_PAGE", "")} ${t(translations, parts[0])}`

            }
        }


        return touched && error ? <ul className={`error ${error ? '' : 'hide'}`}><li style={{ listStyle: "disc", marginLeft: "15px" }}><span className="error normal" id="js-err-msg">{messageError}</span></li></ul> : false
    }

    renderErrorFileState(message) {
        return message != '' ? <ul className={`error ${message ? '' : 'hide'}`}><li style={{ listStyle: "disc", marginLeft: "15px" }}><span className="error normal" id="js-err-msg">{message}</span></li></ul> : ''
    }

    renderError({ meta: { touched, error } }) {
        const {
            translationjob
        } = this.props
        const translations: Map<string, any> = fromJS(translationjob.translation)
        return touched && error ? <div><span className="error normal" id="js-err-msg">{t(translations, error)}</span></div> : false
    }

    renderErrorCV({ meta: { touched, error } }) {
        const { publicJobDetail, translationjob } = this.props
        const job = publicJobDetail.job
        const translations: Map<string, any> = fromJS(translationjob.translation)
        return touched && error ? <div><span className="error normal" id="js-err-msg">{job.document_type + t(translations, error)}</span></div> : false
    }

    renderSubmitSuccess() {
        const parser: Object = new UAParser();
        const isMobile: boolean = parser.getDevice().type === 'mobile'
        const { translationjob } = this.props
        const translations: Map<string, any> = fromJS(translationjob.translation)

        if (isMobile) {
            const isiOS: boolean = parser.getOS().name === 'iOS'
            let sourceLogo: Object

            if (isiOS) {
                sourceLogo =
                    <a href="https://itunes.apple.com/id/app/astronaut-always-be-interviewing/id1098124247?mt=8">
                        <img src={imgAppStore} />
                    </a>
            } else {
                sourceLogo =
                    <a href="https://play.google.com/store/apps/details?id=co.astrnt.androidqa">
                        <img src={imgGooglePlay} />
                    </a>
            }
            return (
                <div className="big-panel p-40">
                    <div className="text-center">
                        <img src={imgSubmitted} className="m-b-24" alt="Application Submitted" />
                        <h1 className="heading2 m-b-24">{t(translations, 'LABEL_APPLICATION_SUBMITED')}</h1>
                        <p className="heading4 p-b-24">{t(translations, 'LABEL_CONGRATULATIONS')}, <b>{this.state.name}!</b> {t(translations, 'LABEL_HAVE_SUCCESS_APPLIED')} <b>{this.state.email}</b> {t(translations, 'LABEL_WITH_LINK_TO_INTERVIEW')}.</p>
                    </div>
                    <p className="heading4">{t(translations, 'LABEL_TO_WAIT')}</p>
                    <p className="heading4">{t(translations, 'LABEL_STEPS')}:</p>
                    <p className="heading4">1. {t(translations, 'LABEL_STEPS_1')}:</p>
                    {sourceLogo}
                    <p className="heading4">2. {t(translations, 'LABEL_STEPS_2')}, <a href={this.state.url} className="text-inherit underline">{t(translations, 'LABEL_STEPS_2_1')}</a> {t(translations, 'LABEL_STEPS_2_2')}</p>
                </div>
            )
        } else {
            return (
                <div className="big-panel text-center p-40">
                    <img src={imgSubmitted} className="m-b-24" alt="Application Submitted" />
                    <h1 className="heading2 m-b-24">{t(translations, 'LABEL_APPLICATION_SUBMITED')}</h1>
                    <p className="heading4 p-b-24">{t(translations, 'LABEL_CONGRATULATIONS')}, <b>{this.state.name}!</b> {t(translations, 'LABEL_HAVE_SUCCESS_APPLIED')} <b>{this.state.email}</b> {t(translations, 'LABEL_WITH_LINK_TO_INTERVIEW')}.</p>
                    <p className="heading4">{t(translations, 'LABEL_TO_WAIT_2')} <a href={this.state.url} className="text-inherit underline">{t(translations, 'LABEL_STEPS_2_1')}</a> {t(translations, 'LABEL_TO_DO_INTERVIEW_NOW')} <b>{this.state.code}</b> {t(translations, 'LABEL_ASTRONAUT_QNA_APP')}.</p>
                </div>
            )
        }
    }

    createMarkup(message) {
        return { __html: message };
    }

    handleVideoClick(companyId, videoId) {
        const { accessLog } = this.props
        accessLog(companyId, "intro_video", videoId);
    }

    renderErrorAdditionalField({ meta: { touched, error } }) {
        return touched && error ? <div><span className="error normal" id="js-err-msg">{error}</span></div> : false
    }

    renderAdditionalField(additionalField, index) {
        const {
            fields: { file },
            formState,
            translationjob
        } = this.props
        const translations: Map<string, any> = fromJS(translationjob.translation)

        const {
            id,
            label,
            input_type,
            accept,
            min,
            max,
            description,
            has_description,
            is_mandatory,
            multiple,
            options,
            maxWords,
            minWords,
            maxOptions
        } = additionalField

        let tempAdditionalField = this.state.tempAdditionalFields[index]
        let value = null;
        let errorMessage = '';
        if (tempAdditionalField) {
            value = tempAdditionalField.value
            errorMessage = tempAdditionalField.errorMessage
        }

        let renderInput = <div className="form-group">
            <label><span className="capitalize">{label}</span>{is_mandatory !== 1 ? ` (${t(translations, 'LABEL_OPTIONAL')})` : ''}</label>
            {description ? <label className="label-desc">{description}</label> : null}
            <Field
                name={`${snakeCase(label)}-${id}`}
                onFocus={this.inputFocus}
                onBlur={this.inputBlur}
                type="text"
                placeholder={label}
                className={`js-additional-fields-${id}`}
                component="input"
                onChange={(e) => this.removeErrorMessage(id)} />
            <Field name={`${snakeCase(label)}-${id}`} component={this.renderErrorAdditionalField} />
        </div>
        if (input_type == 1) {
            renderInput = <div className="form-group" key={index}>
                <label><span className="capitalize">{label}</span>{is_mandatory !== 1 ? ` (${t(translations, 'LABEL_OPTIONAL')})` : ''}</label>
                {description ? <label className="label-desc">{description}</label> : null}
                {maxWords ? <label className="label-desc"><b>{this.countWord(formState[`${snakeCase(label)}-${id}`])}</b>/{maxWords} {t(translations, 'LABEL_WORDS')} ({t(translations, 'LABEL_AT_LEAST')} {minWords})</label> : null}
                {maxWords ?
                    <Field
                        name={`${snakeCase(label)}-${id}`}
                        onFocus={this.inputFocus}
                        onBlur={this.inputBlur}
                        normalize={(value, previousValue) => normalizeTextLenght(value, previousValue, maxWords)}
                        className={`js-additional-fields-${id}`}
                        component="textarea"
                        onChange={(e) => this.resizeTextArea(e, id)}
                        placeholder={label}
                    />
                    :
                    <Field
                        name={`${snakeCase(label)}-${id}`}
                        onFocus={this.inputFocus}
                        onBlur={this.inputBlur}
                        className={`js-additional-fields-${id}`}
                        component="textarea"
                        onChange={(e) => this.resizeTextArea(e, id)}
                        placeholder={label}
                    />
                }
                <Field name={`${snakeCase(label)}-${id}`} component={this.renderErrorAdditionalField} />
            </div>
        } else if (input_type == 2) {
            renderInput = <div className="form-group">
                <label>{label} <span className="normal">{is_mandatory !== 1 ? ` (${t(translations, 'LABEL_OPTIONAL')})` : ''}</span></label>
                {description ? <label className="label-desc">{description}</label> : null}
                {maxOptions ? <label className="label-desc">{t(translations, 'LABEL_MAX')} {t(translations, 'LABEL_CHOOSE')} {maxOptions} {t(translations, 'LABEL_OPTIONS')}</label> : null}
                {maxOptions ?
                    <Field
                        name={`${snakeCase(label)}-${id}`}
                        component={CheckBoxGroup}
                        options={options}
                        maxOptions={maxOptions}
                        onChange={(e) => this.removeErrorMessage(id)}
                    />
                    :
                    <Field
                        name={`${snakeCase(label)}-${id}`}
                        component={CheckBoxGroup}
                        options={options}
                        onChange={(e) => this.removeErrorMessage(id)}
                    />
                }
                <Field name={`${snakeCase(label)}-${id}`} component={this.renderErrorAdditionalField} />
            </div>
        } else if (input_type == 3) {
            renderInput = <div className="form-group">
                <label><span className="capitalize">{label}</span>{is_mandatory !== 1 ? ` (${t(translations, 'LABEL_OPTIONAL')})` : ''}</label>
                {description ? <label className="label-desc">{description}</label> : null}
                <Field
                    name={`${snakeCase(label)}-${id}`}
                    type="number"
                    placeholder={label}
                    className={`js-additional-fields-${id}`}
                    component={RenderInput}
                    step="any"
                    min={min}
                    max={max}
                    normalize={(value, previousValue) => normalizeNumberLength(value, previousValue, min, max)}
                />
                <Field name={`${snakeCase(label)}-${id}`} component={this.renderErrorAdditionalField} />
            </div>
        } else if (input_type == 4) {
            let selectOptions = options.map(opt => {
                return {
                    label: opt,
                    value: opt
                }
            })
            renderInput = <div className="form-group">
                <label><span className="capitalize">{label}</span>{is_mandatory !== 1 ? ` (${t(translations, 'LABEL_OPTIONAL')})` : ''}</label>
                {description ? <label className="label-desc">{description}</label> : null}
                <Field
                    name={`${snakeCase(label)}-${id}`}
                    component={RenderSelect}
                    options={selectOptions}
                />
                <Field name={`${snakeCase(label)}-${id}`} component={this.renderErrorAdditionalField} />
            </div>
        } else if (input_type == 5) {
            renderInput = <div className="form-group">
                <label><span className="capitalize">{label}</span>{is_mandatory !== 1 ? ` (${t(translations, 'LABEL_OPTIONAL')})` : ''}</label>
                {description ? <label className="label-desc">{description}</label> : null}
                <Field
                    name={`${snakeCase(label)}-${id}`}
                    component={RadioButtonGroup}
                    options={options}
                />
                <Field name={`${snakeCase(label)}-${id}`} component={this.renderErrorAdditionalField} />
            </div>
        } else if (input_type == 6) {
            renderInput = <div className="form-group">
                <label><span className="capitalize">{label}</span>{is_mandatory !== 1 ? ` (${t(translations, 'LABEL_OPTIONAL')})` : ''}</label>
                {description ? <label className="label-desc">{description}</label> : null}
                <div className="input-group">
                    <DatePicker
                        onChange={(e) => this.handleChangeAdditionalFieldValue(e, index)}
                        selected={value ? moment(value) : ''}
                        value={value ? moment(value).format('YYYY-MM-DD') : ''}
                    />
                    <span className="input-group-addon"><i className="fa fa-calendar"></i></span>
                </div>
                <Field name={`${snakeCase(label)}-${id}`} component={this.renderErrorAdditionalField} />
            </div>
        } else if (input_type == 7) {
            let uploaded = false
            let file_uploader = []
            if (value) {
                uploaded = 1
                file_uploader.push(
                    <Fragment>
                        <div className="div-file">
                            <div className="div-filename horizontal-item--between">
                                <div className="vertical-item--center">
                                    <i className="icon icon-i-file-doc"></i>
                                </div>
                                <label className="m-l-15">{value.name}</label>
                                <div className="button-action-container">
                                    <i data-toggle="tooltip" data-placement="top" title={`${t(translations, 'DELETE_LANDING_FORM')}`} className="icon icon-i-del-doc" onClick={(e) => this.handleRemoveAdditionalFieldValue(index)}></i>
                                </div>
                            </div>
                        </div>
                        {this.renderErrorFileState(errorMessage)}
                    </Fragment>
                )
            }
            renderInput = <div className='div-multidoc-action'>
                <div className='horizontal-item--between m-b-8'>
                    <label><span className="capitalize">{label}</span>{is_mandatory !== 1 ? ` (${t(translations, 'LABEL_OPTIONAL')})` : ''}</label>
                    {description ? <label className="label-desc">{description}</label> : null}
                    {
                        !uploaded && <div className='div-action-icon'>
                            <i data-toggle="tooltip" data-placement="top" title={`${t(translations, 'ADD_LINK_LANDING_FORM')}`} className='icon-i-add-link hide'></i>
                            <i data-toggle="tooltip" data-placement="top" title={`${t(translations, 'ADD_DOCUMENT_LANDING_FORM')}`} onClick={(e) => {
                                this.setState({ currentAdditionalFieldIndex: index }, () => {
                                    if (!uploaded) {
                                        this.uploadAdditionalFieldRef.current.accept = accept;
                                        this.uploadAdditionalFieldRef.current.click();
                                    }
                                })
                            }} className={`icon-i-add-file m-l-8 ${uploaded ? 'disabled' : ''}`}></i>

                        </div>
                    }

                </div>
                {file_uploader}
                <Field name={`${snakeCase(label)}-${id}`} component={this.renderErrorFile} />
            </div>
        }
        return renderInput
    }

    handleAdditionalFileSave(e) {
        const {
            translationjob
        } = this.props
        const translations: Map<string, any> = fromJS(translationjob.translation)

        let index = this.state.currentAdditionalFieldIndex
        const file = e.target.files[0]
        let tempAdditionalFields = this.state.tempAdditionalFields
        if (typeof file != 'undefined') {
            let newValue = file
            if (tempAdditionalFields[index].accept != '*.*') {
                let type = newValue.name.split('.').pop()
                let acceptedFiles = tempAdditionalFields[index].accept.split(',')
                if (!acceptedFiles.includes(`.${type}`)) {
                    tempAdditionalFields[index].errorMessage = `${t(translations, 'NOT_SUPPORTED_FILE_LANDING_PAGE')}`
                    tempAdditionalFields[index].value = newValue
                } else {
                    tempAdditionalFields[index].value = newValue
                    this.props.changeFieldValue(`${snakeCase(tempAdditionalFields[index].label)}-${tempAdditionalFields[index].id}`, newValue)
                }
            } else {
                tempAdditionalFields[index].value = newValue
                this.props.changeFieldValue(`${snakeCase(tempAdditionalFields[index].label)}-${tempAdditionalFields[index].id}`, newValue)
            }
        } else {
            tempAdditionalFields[index].errorMessage = `${t(translations, 'NOT_SUPPORTED_FILE_LANDING_PAGE')}`
        }
        this.setState({ tempAdditionalFields: tempAdditionalFields })

    }

    handleChangeAdditionalFieldValue(e, index) {
        let tempAdditionalFields = this.state.tempAdditionalFields
        if (tempAdditionalFields[index].input_type == 6) {
            this.props.changeFieldValue(`${snakeCase(tempAdditionalFields[index].label)}-${tempAdditionalFields[index].id}`, moment(e).format('YYYY-MM-DD'))
        } else {
            this.props.changeFieldValue(`${snakeCase(tempAdditionalFields[index].label)}-${tempAdditionalFields[index].id}`, e)
        }
        tempAdditionalFields[index].value = e
        this.setState({ tempAdditionalFields: tempAdditionalFields })
    }

    handleRemoveAdditionalFieldValue(index) {
        let tempAdditionalFields = this.state.tempAdditionalFields
        let newValue = null;
        tempAdditionalFields[index].value = newValue
        this.props.changeFieldValue(`${snakeCase(tempAdditionalFields[index].label)}-${tempAdditionalFields[index].id}`, newValue)
        this.setState({ tempAdditionalFields: tempAdditionalFields, currentAdditionalFieldIndex: '' })
    }

    renderErrorFile({ meta: { touched, error } }) {
        return touched && error ? <div> <ul className={`error ${error ? '' : 'hide'}`}><li style={{ listStyle: "disc", marginLeft: "15px" }}><span className="error normal" id="js-err-msg">{error}</span></li></ul></div> : false
    }

    renderLanguageFields = ({ fields }) => {
        const { formValues, translationjob } = this.props;
        const { uploadProgress } = this.state;
        const isUploadInProgress = uploadProgress === 'up';
        
        // Check if CV upload is in progress through documentAttachment state
        const { documentAttachment } = this.props;
        const fileAttachments = documentAttachment && documentAttachment.file_attachment ? documentAttachment.file_attachment : [];
        const isCVUploadInProgress = fileAttachments.some(file => 
            file.progress !== undefined && file.progress < 100 && file.status !== 'finish' && file.status !== 'failed'
        );
        const isAnyUploadInProgress = isUploadInProgress || isCVUploadInProgress;
        
        // Check if there's any language data from API
        const hasLanguageData = formValues && formValues.languages && formValues.languages.length > 0;
        
        // Get translations
        const translations = fromJS(translationjob.translation);
        
        return (
            <div>
                {fields.map((member, index) => (
                    <div key={member} style={{ marginTop: '8px', marginBottom: '8px' }}>
                        <label style={{ marginBottom: '8px', fontWeight: 'bold' }}>
                            {index === 0 ? t(translations, 'PROFILE_LANGUAGE') : `${t(translations, 'PROFILE_LANGUAGE')} ${index + 1}`}
                        </label>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <div style={{ flex: '1' }}>
                                <Field
                                    name={member}
                                    component="input"
                                    type="text"
                                    className="form-control"
                                    disabled={isAnyUploadInProgress} />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <button
                                    type="button"
                                    className="btn"
                                    style={{
                                        backgroundColor: 'transparent',
                                        border: 'none',
                                        color: '#dc3545',
                                        padding: '8px',
                                        borderRadius: '4px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '45px',
                                        height: '38px'
                                    }}
                                    onClick={() => {
                                        fields.remove(index);
                                        // Force component to re-render to ensure proper index update
                                        this.forceUpdate();
                                    }}
                                    disabled={isAnyUploadInProgress}
                                    title="Remove language">
                                    <i className="fa fa-trash" style={{ fontSize: '18px' }}></i>
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
                {/* Only show Add More Language button if there's data from API */}
                {hasLanguageData && (
                    <button
                        type="button"
                        className="btn"
                        style={{ 
                            color: 'white', 
                            backgroundColor: '#564FDB',
                            border: 'none',
                            borderRadius: '4px',
                            padding: '10px 15px',
                            width: '100%',
                            marginTop: '10px'
                        }}
                        onClick={() => fields.push('')}
                        disabled={isAnyUploadInProgress}>
                        <i className="fa fa-plus m-r-5"></i>
                        {t(translations, 'PROFILE_ADD_MORE_LANGUAGE')}
                    </button>
                )}
            </div>
        );
    }

    renderCertificationFields = ({ fields }) => {
        const { formValues, translationjob } = this.props;
        const { uploadProgress } = this.state;
        const isUploadInProgress = uploadProgress === 'up';
        
        // Check if CV upload is in progress through documentAttachment state
        const { documentAttachment } = this.props;
        const fileAttachments = documentAttachment && documentAttachment.file_attachment ? documentAttachment.file_attachment : [];
        const isCVUploadInProgress = fileAttachments.some(file => 
            file.progress !== undefined && file.progress < 100 && file.status !== 'finish' && file.status !== 'failed'
        );
        const isAnyUploadInProgress = isUploadInProgress || isCVUploadInProgress;
        
        // Check if there's any certification data from API
        const hasCertificationData = formValues && formValues.certifications && formValues.certifications.length > 0;
        
        // Get translations
        const translations = fromJS(translationjob.translation);
        
        return (
            <div>
                {fields.map((member, index) => (
                    <div key={member} style={{ marginTop: '8px', marginBottom: '8px' }}>
                        <label style={{ marginBottom: '8px', fontWeight: 'bold' }}>
                            {index === 0 ? t(translations, 'PROFILE_CERTIFICATION') : `${t(translations, 'PROFILE_CERTIFICATION')} ${index + 1}`}
                        </label>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <div style={{ flex: '1' }}>
                                <Field
                                    name={member}
                                    component="input"
                                    type="text"
                                    className="form-control"
                                    disabled={isAnyUploadInProgress} />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <button
                                    type="button"
                                    className="btn"
                                    style={{
                                        backgroundColor: 'transparent',
                                        border: 'none',
                                        color: '#dc3545',
                                        padding: '8px',
                                        borderRadius: '4px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '45px',
                                        height: '38px'
                                    }}
                                    onClick={() => {
                                        fields.remove(index);
                                        // Force component to re-render to ensure proper index update
                                        this.forceUpdate();
                                    }}
                                    disabled={isAnyUploadInProgress}
                                    title="Remove certification">
                                    <i className="fa fa-trash" style={{ fontSize: '18px' }}></i>
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
                {/* Only show Add More Certification button if there's data from API */}
                {hasCertificationData && (
                    <button
                        type="button"
                        className="btn"
                        style={{ 
                            color: 'white', 
                            backgroundColor: '#564FDB',
                            border: 'none',
                            borderRadius: '4px',
                            padding: '10px 15px',
                            width: '100%',
                            marginTop: '10px'
                        }}
                        onClick={() => fields.push('')}
                        disabled={isAnyUploadInProgress}>
                        <i className="fa fa-plus m-r-5"></i>
                        {t(translations, 'PROFILE_ADD_MORE_CERTIFICATION')}
                    </button>
                )}
            </div>
        );
    }

    renderEmploymentHistoryFields = ({ fields }) => {
        const { formValues, translationjob } = this.props;
        const { uploadProgress } = this.state;
        const isUploadInProgress = uploadProgress === 'up';
        
        // Check if CV upload is in progress through documentAttachment state
        const { documentAttachment } = this.props;
        const fileAttachments = documentAttachment && documentAttachment.file_attachment ? documentAttachment.file_attachment : [];
        const isCVUploadInProgress = fileAttachments.some(file => 
            file.progress !== undefined && file.progress < 100 && file.status !== 'finish' && file.status !== 'failed'
        );
        const isAnyUploadInProgress = isUploadInProgress || isCVUploadInProgress;
        
        // Get translations
        const translations = fromJS(translationjob.translation);
        
        return (
            <div>
                {fields.length === 0 && (
                    <div style={{ 
                        padding: '4px',
                        fontSize: '13px',
                        color: '#808080',
                        marginBottom: '3px'
                    }}>
                        No employment history have been added to this candidate.
                    </div>
                )}
                {fields.map((member, index) => {
                    return (
                        <div key={index} className="employment-history-entry p-3 mb-3 border rounded">
                            <div className="form-group">
                                <label>{t(translations, 'PROFILE_COMPANY_NAME_REQUIRED')}</label>
                                <Field
                                    name={`${member}.company_name`}
                                    type="text"
                                    component="input"
                                    className="form-control"
                                    disabled={isAnyUploadInProgress} />
                                <Field name={`${member}.company_name`} component={this.renderError} />
                            </div>
                            <div className="form-group">
                                <label>{t(translations, 'PROFILE_INDUSTRY')}</label>
                                <Field
                                    name={`${member}.industry`}
                                    type="text"
                                    component="input"
                                    className="form-control"
                                    disabled={isAnyUploadInProgress} />
                            </div>
                            <div className="form-group">
                                <label>{t(translations, 'PROFILE_JOB_FAMILY')}</label>
                                <Field
                                    name={`${member}.job_family`}
                                    component="select"
                                    className="form-control"
                                    disabled={isAnyUploadInProgress}>
                                    <option value="">Select Job Family</option>
                                    <option value="Business and Financial Operations">Business and Financial Operations</option>
                                    <option value="Arts, Design, Entertainment, Sports, and Media">Arts, Design, Entertainment, Sports, and Media</option>
                                    <option value="Computer and Mathematical">Computer and Mathematical</option>
                                    <option value="Healthcare Practitioners and Technical">Healthcare Practitioners and Technical</option>
                                    <option value="Educational Instruction and Library">Educational Instruction and Library</option>
                                    <option value="Production">Production</option>
                                    <option value="Legal">Legal</option>
                                    <option value="Management">Management</option>
                                    <option value="Sales and Related">Sales and Related</option>
                                    <option value="Architecture and Engineering">Architecture and Engineering</option>
                                    <option value="Farming, Fishing, and Forestry">Farming, Fishing, and Forestry</option>
                                    <option value="Life, Physical, and Social Science">Life, Physical, and Social Science</option>
                                    <option value="Military Specific">Military Specific</option>
                                    <option value="Transportation and Material Moving">Transportation and Material Moving</option>
                                    <option value="Installation, Maintenance, and Repair">Installation, Maintenance, and Repair</option>
                                    <option value="Personal Care and Service">Personal Care and Service</option>
                                    <option value="Protective Service">Protective Service</option>
                                    <option value="Food Preparation and Serving Related">Food Preparation and Serving Related</option>
                                    <option value="Office and Administrative Support">Office and Administrative Support</option>
                                    <option value="Construction and Extraction">Construction and Extraction</option>
                                    <option value="Building and Grounds Cleaning and Maintenance">Building and Grounds Cleaning and Maintenance</option>
                                    <option value="Community and Social Service">Community and Social Service</option>
                                    <option value="Healthcare Support">Healthcare Support</option>
                                </Field>
                            </div>
                            <div className="form-group">
                                <label>{t(translations, 'PROFILE_JOB_TITLE')}</label>
                                <Field
                                    name={`${member}.job_title`}
                                    type="text"
                                    component="input"
                                    className="form-control"
                                    disabled={isAnyUploadInProgress} />
                            </div>
                            <div className="form-group">
                                <label>{t(translations, 'PROFILE_JOB_LEVEL')}</label>
                                <Field
                                    name={`${member}.job_level`}
                                    component="select"
                                    className="form-control"
                                    disabled={isAnyUploadInProgress}>
                                    <option value="">Select Job Level</option>
                                    <option value="Intern">Intern</option>
                                    <option value="Entry-Level">Entry-Level</option>
                                    <option value="Associate">Associate</option>
                                    <option value="Mid-Level">Mid-Level</option>
                                    <option value="Senior">Senior</option>
                                    <option value="Lead">Lead</option>
                                    <option value="Manager">Manager</option>
                                    <option value="Director">Director</option>
                                    <option value="Vice President (VP)">Vice President (VP)</option>
                                    <option value="C-Suite (CEO, CFO, CTO, etc.)">C-Suite (CEO, CFO, CTO, etc.)</option>
                                    <option value="Founder/Owner">Founder/Owner</option>
                                </Field>
                            </div>
                            <div className="form-group">
                                <label>{t(translations, 'PROFILE_START_DATE')}</label>
                                <Field
                                    name={`${member}.start_date`}
                                    type="month"
                                    component="input"
                                    className="form-control"
                                    disabled={isAnyUploadInProgress} />
                            </div>
                            <div className="form-group">
                                <label>{t(translations, 'PROFILE_END_DATE')}</label>
                                <Field
                                    name={`${member}.end_date`}
                                    type="month"
                                    component="input"
                                    disabled={isAnyUploadInProgress || (formValues.employment_history && formValues.employment_history[index] && formValues.employment_history[index].is_current_job)}
                                    className="form-control"
                                    style={{
                                        backgroundColor: (isAnyUploadInProgress || (formValues.employment_history && formValues.employment_history[index] && formValues.employment_history[index].is_current_job)) ? '#f5f5f5' : '#ffffff'
                                    }} />
                                <div className="mt-2" style={{ marginTop: '15px' }}>
                                    <label className="inline-content normal checkbox-container employment-history-entry" style={{ textAlign: 'left', justifyContent: 'flex-start', display: 'flex', alignItems: 'center' }}>
                                        <Field
                                            name={`${member}.is_current_job`}
                                            type="checkbox"
                                            component="input"
                                            checked={formValues && formValues.employment_history && formValues.employment_history[index] && formValues.employment_history[index].is_current_job}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    this.props.changeFieldValue(`${member}.end_date`, '');
                                                }
                                            }}
                                            className="btn-checkbox m-r-10"
                                            disabled={isAnyUploadInProgress} />
                                        {t(translations, 'PROFILE_CURRENTLY_WORKING_HERE')}
                                        <span className="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="form-group">
                                <label>{t(translations, 'PROFILE_JOB_DESCRIPTION')}</label>
                                <Field
                                    name={`${member}.job_description`}
                                    component="textarea"
                                    className="form-control"
                                    rows="4"
                                    style={{ minHeight: '70px', resize: 'vertical' }}
                                    disabled={isAnyUploadInProgress} />
                            </div>
                            <div className="text-right mt-3">
                                <button
                                    type="button"
                                    className="btn"
                                    style={{
                                        color: 'red',
                                        backgroundColor: 'transparent',
                                        border: 'none',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        marginBottom: '10px',
                                        fontWeight: 'bold'
                                    }}
                                    onClick={() => fields.remove(index)}
                                    disabled={isAnyUploadInProgress}>
                                    {t(translations, 'PROFILE_DELETE')}
                                </button>
                            </div>
                        </div>
                    );
                })}
                
                <button
                    type="button"
                    className="btn"
                    style={{ 
                        color: '#564FDB', 
                        backgroundColor: 'transparent',
                        border: 'none',
                        borderRadius: '0',
                        padding: '8px 0'
                    }}
                    onClick={() => fields.push({})}
                    disabled={isAnyUploadInProgress}>
                    <i className="fa fa-plus m-r-5"></i>
                    {t(translations, 'PROFILE_ADD_EMPLOYMENT_HISTORY')}
                </button>
            </div>
        );
    }

    renderEducationBackgroundFields = ({ fields }) => {
        const { formValues, translationjob } = this.props;
        const { uploadProgress } = this.state;
        const isUploadInProgress = uploadProgress === 'up';
        
        // Check if CV upload is in progress through documentAttachment state
        const { documentAttachment } = this.props;
        const fileAttachments = documentAttachment && documentAttachment.file_attachment ? documentAttachment.file_attachment : [];
        const isCVUploadInProgress = fileAttachments.some(file => 
            file.progress !== undefined && file.progress < 100 && file.status !== 'finish' && file.status !== 'failed'
        );
        const isAnyUploadInProgress = isUploadInProgress || isCVUploadInProgress;
        
        // Get translations
        const translations = fromJS(translationjob.translation);
        
        return (
            <div>
                {fields.length === 0 && (
                    <div style={{ 
                        padding: '4px',
                        fontSize: '13px',
                        color: '#808080',
                        marginBottom: '3px'
                    }}>
                        No education background have been added to this candidate.
                    </div>
                )}
                {fields.map((member, index) => {
                    
                    return (
                    <div key={index} style={{ marginBottom: '20px', padding: '15px' }}>
                        <div className="form-group">
                            <label>{t(translations, 'PROFILE_INSTITUTIONAL_NAME_REQUIRED')}</label>
                            <Field
                                name={`${member}.institutional_name`}
                                component="input"
                                type="text"
                                className="form-control"
                                disabled={isAnyUploadInProgress} />
                        </div>
                        
                        <div className="form-group">
                            <label>{t(translations, 'PROFILE_FIELD_OF_STUDY')}</label>
                            <Field
                                name={`${member}.field_of_study`}
                                component="input"
                                type="text"
                                className="form-control"
                                disabled={isAnyUploadInProgress} />
                        </div>
                        
                        <div className="form-group">
                            <label>{t(translations, 'PROFILE_DEGREE_OBTAINED')}</label>
                            <Field
                                name={`${member}.degree_obtained`}
                                component="input"
                                type="text"
                                className="form-control"
                                disabled={isAnyUploadInProgress} />
                        </div>
                        
                        <div className="form-group">
                            <label>{t(translations, 'PROFILE_DATE_ATTENDED')}</label>
                            <Field
                                name={`${member}.date_attended`}
                                type="month"
                                component="input"
                                className="form-control"
                                disabled={isAnyUploadInProgress} />
                        </div>
                        
                        <div className="form-group">
                            <label>{t(translations, 'PROFILE_GRADUATION_DATE')}</label>
                            <Field
                                name={`${member}.graduation_date`}
                                type="month"
                                component="input"
                                disabled={isAnyUploadInProgress || (formValues.education_background && formValues.education_background[index] && formValues.education_background[index].is_currently_studying)}
                                className="form-control"
                                style={{
                                    backgroundColor: (isAnyUploadInProgress || (formValues.education_background && formValues.education_background[index] && formValues.education_background[index].is_currently_studying)) ? '#f5f5f5' : '#ffffff'
                                }} />
                            <div className="form-group mt-2" style={{ marginTop: '15px' }}>
                                <label className="inline-content normal checkbox-container education-background-entry">
                                    <Field
                                        name={`${member}.is_currently_studying`}
                                        type="checkbox"
                                        component="input"
                                        checked={formValues && formValues.education_background && formValues.education_background[index] && formValues.education_background[index].is_currently_studying}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                this.props.changeFieldValue(`${member}.graduation_date`, '');
                                            }
                                        }}
                                        className="btn-checkbox m-r-10"
                                        disabled={isAnyUploadInProgress} />
                                    {t(translations, 'PROFILE_CURRENTLY_STUDYING_HERE')}
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                        </div>
                        
                        <div className="form-group">
                            <label>{t(translations, 'PROFILE_GPA')}</label>
                            <div className="row" style={{ alignItems: 'center' }}>
                                <div className="col-md-4">
                                    <Field
                                        name={`${member}.gpa_score`}
                                        component="input"
                                        type="text"
                                        className="form-control"
                                        disabled={isAnyUploadInProgress} />
                                </div>
                                <div className="col-md-2" style={{ textAlign: 'center', paddingTop: '8px' }}>
                                    <span>{t(translations, 'PROFILE_OUT_OF')}</span>
                                </div>
                                <div className="col-md-4">
                                    <Field
                                        name={`${member}.gpa_scale`}
                                        component="input"
                                        type="text"
                                        placeholder='4.00'
                                        className="form-control"
                                        disabled={isAnyUploadInProgress} />
                                </div>
                            </div>
                        </div>
                        
                        <div className="text-right">
                            <button
                                type="button"
                                className="btn"
                                style={{
                                    color: 'red',
                                    backgroundColor: 'transparent',
                                    border: 'none',
                                    borderRadius: '4px',
                                    padding: '8px 16px',
                                    fontWeight: 'bold'
                                }}
                                onClick={() => fields.remove(index)}
                                disabled={isAnyUploadInProgress}>
                                {t(translations, 'PROFILE_DELETE')}
                            </button>
                        </div>
                    </div>
                    );
                })}
                
                <button
                    type="button"
                    className="btn"
                    style={{ 
                        color: '#564FDB', 
                        backgroundColor: 'transparent',
                        border: 'none',
                        borderRadius: '0',
                        padding: '8px 0'
                    }}
                    onClick={() => fields.push({})}
                    disabled={isAnyUploadInProgress}>
                    <i className="fa fa-plus m-r-5"></i>
                    {t(translations, 'PROFILE_ADD_EDUCATIONAL_BACKGROUND')}
                </button>
            </div>
        );
    }

    renderKeyAchievementFields = ({ fields }) => {
        const { formValues, translationjob } = this.props;
        const { uploadProgress } = this.state;
        const isUploadInProgress = uploadProgress === 'up';
        
        // Check if CV upload is in progress through documentAttachment state
        const { documentAttachment } = this.props;
        const fileAttachments = documentAttachment && documentAttachment.file_attachment ? documentAttachment.file_attachment : [];
        const isCVUploadInProgress = fileAttachments.some(file => 
            file.progress !== undefined && file.progress < 100 && file.status !== 'finish' && file.status !== 'failed'
        );
        const isAnyUploadInProgress = isUploadInProgress || isCVUploadInProgress;
        
        // Get translations
        const translations = fromJS(translationjob.translation);
        
        return (
            <div>
                {fields.map((member, index) => {
                    const achievementText = formValues && formValues.key_achievements && formValues.key_achievements[index] && formValues.key_achievements[index].achievement ? formValues.key_achievements[index].achievement : '';
                    const currentLength = achievementText.length;
                    const maxLength = 700;
                    
                    return (
                        <div key={`achievement-field-${index}`} className="mb-3">
                            <div className="form-group">
                                <label>{t(translations, 'PROFILE_ACHIEVEMENT')} {index + 1}</label>
                                <Field
                                    name={`${member}.achievement`}
                                    component="textarea"
                                    className="form-control"
                                    rows="4"
                                    style={{ minHeight: '70px', resize: 'vertical' }}
                                    maxLength={maxLength}
                                    disabled={isAnyUploadInProgress} />
                                <div style={{ textAlign: 'right', fontSize: '12px', color: '#666', marginTop: '5px' }}>
                                    {currentLength} / {maxLength} characters
                                </div>
                            </div>
                            <div className="form-group">
                                <label>{t(translations, 'PROFILE_DATE')}</label>
                                <Field
                                    name={`${member}.date`}
                                    type="month"
                                    component="input"
                                    className="form-control"
                                    disabled={isAnyUploadInProgress} />
                            </div>
                            <div className="text-right">
                                <button
                                    type="button"
                                    className="btn"
                                    style={{
                                        color: 'red',
                                        backgroundColor: 'transparent',
                                        border: 'none',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        fontWeight: 'bold'
                                    }}
                                    onClick={() => fields.remove(index)}
                                    disabled={isAnyUploadInProgress}>
                                    {t(translations, 'PROFILE_DELETE')}
                                </button>
                            </div>
                        </div>
                    );
                })}
                <button
                    type="button"
                    className="btn"
                    style={{ 
                        color: '#564FDB', 
                        backgroundColor: 'transparent',
                        border: 'none',
                        borderRadius: '0',
                        padding: '8px 0'
                    }}
                    onClick={() => fields.push({})}
                    disabled={isAnyUploadInProgress}>
                    <i className="fa fa-plus m-r-5"></i>
                    {t(translations, 'PROFILE_KEY_ACHIEVEMENT')}
                </button>
            </div>
        );
    }

    render() {
        const {
            fields: { file },
            publicJobDetail,
            handleSubmit,
            submitting,
            pristine,
            errors,
            globalAddSweetAlertData,
            error_email_exists,
            globalSweetAlertData,
            formValues,
            publicJobCustom,
            formState,
            translationjob
        } = this.props
        const { experience,
            isConsent,
            isCompliance,
            testColor,
            uploadProgress,
            isWhatsappReminder,
            formDocumentList,
            cvName } = this.state
    
        
        const thisPageURL = window.location.href
        const company = publicJobDetail.company || {}
        let customColor = publicJobCustom.color
        const fontColor = company.font_color
        const backgroundImage = publicJobCustom.backgroundImage
        const socialMedia = publicJobCustom.social_media
        customColor = company.brand_color || customColor

        const colorCondition = fontColor == '#000000' ? fontColor : customColor

        // Determine if forms should be disabled during upload
        const isUploadInProgress = uploadProgress === 'up';

        // Check if CV upload is in progress through documentAttachment state
        const { documentAttachment } = this.props;
        const fileAttachments = documentAttachment && documentAttachment.file_attachment ? documentAttachment.file_attachment : [];
        const isCVUploadInProgress = fileAttachments.some(file => 
            file.progress !== undefined && file.progress < 100 && file.status !== 'finish' && file.status !== 'failed'
        );

        // Combine both upload states to determine if forms should be disabled
        const isAnyUploadInProgress = isUploadInProgress || isCVUploadInProgress;

        var countText;
        const text_answer = formValues.experience == undefined ? '' : formValues.experience;
        document.styleSheets[0].addRule('.main-gdpr-fluid .checkbox-container .checkmark:after', 'border: solid ' + colorCondition + ';');
        document.styleSheets[0].addRule('.whatsapp-box .checkbox-container .checkmark:after', 'border: solid ' + colorCondition + ';');
        document.styleSheets[0].addRule('.employment-history-entry .checkbox-container .checkmark:after', 'border: solid ' + colorCondition + ';');
        document.styleSheets[0].addRule('.education-background-entry .checkbox-container .checkmark:after', 'border: solid ' + colorCondition + ';');
        
        // Add CSS rules for skills tags
        document.styleSheets[0].addRule('.skills-tags', 'display: flex; flex-wrap: wrap; gap: 8px; min-height: 40px; margin-bottom: 10px;');
        document.styleSheets[0].addRule('.skill-tag', 'display: inline-flex; align-items: center; background-color: ' + colorCondition + '; color: white; padding: 6px 12px; border-radius: 20px; font-size: 14px; margin: 2px;');
        document.styleSheets[0].addRule('.remove-skill-btn', 'background: none; border: none; color: white; margin-left: 8px; cursor: pointer; font-size: 16px; font-weight: bold; padding: 0; width: 20px; height: 20px; border-radius: 50%; display: flex; align-items: center; justify-content: center;');
        document.styleSheets[0].addRule('.remove-skill-btn:hover', 'background-color: rgba(255,255,255,0.2);');
        document.styleSheets[0].addRule('.skills-input-container', 'border: 1px solid #ddd; border-radius: 4px; padding: 10px; background-color: #f9f9f9;');
        if (text_answer.trim().length == 0) {
            countText = 0;
        } else {
            countText = text_answer == "" ? 0 : text_answer.match(/\S+/g).length;
        }

        const job = publicJobDetail.job || {}
        const dueDate = moment(job.due_date).format("DD MMM YYYY")
        const additionalField = publicJobDetail.additionalField || []
        const gdpr_text = publicJobDetail.gdpr_text || []
        const gdpr_agreement_text = publicJobDetail.gdpr_aggrement_text || []
        const job_document_type = job.document_type == 'CV' ? 'Curriculum Vitae' : 'Company Investment Profile'
        const job_video_url = publicJobDetail.job ? publicJobDetail.job.introduction_video : ''
        const videoId = publicJobDetail.job ? publicJobDetail.job.introduction_video : ''
        const video = document.getElementById('video-src')
        const translations = fromJS(translationjob.translation)
        const label_apply = translations ? t(translations, 'LABEL_APPLY_NOW') : ''
        const call_action_message = publicJobDetail.call_action_message || label_apply
        const show_email = true
        const show_due_date = publicJobDetail.show_due_date == null ? 1 : publicJobDetail.show_due_date
        let showWAoption = false
        if (job.whatsapp_notification && job.whatsapp_notification == 1) {
            showWAoption = true
        }
        let finalWidth = '100%'
        let videoStyle = {
            'width': finalWidth,
            'borderRadius': '10px',
        }
        var iconClass;
        var iconColor;
        if (uploadProgress == '') {
            iconClass = 'fa-cloud-upload'
            iconColor = '#999999'
        } else if (uploadProgress == 'up') {
            iconClass = 'fa-soundcloud'
            iconColor = customColor
        } else if (uploadProgress == 'done') {
            iconClass = 'fa-cloud'
            iconColor = customColor
        }

        const handleStyleApplyBorder = () => {
            if (company.font_color == '#000000') {
                return {
                    borderColor: fontColor,
                }
            } else {
                return {
                    borderColor: company.brand_color,
                }
            }
        };

        const handleStyleApply = () => {
            if (company.font_color == '#000000') {
                return {
                    color: fontColor,
                }
            } else {
                return {
                    color: company.brand_color,
                }
            }
        };


        if (video) {
            video.onloadedmetadata = function () {
                if (video.videoHeight > video.videoWidth) {
                    video.style.width = '40%'
                    video.style.left = '30%'
                    video.style.position = 'relative'
                }
                if (video.videoHeight == video.videoWidth) {
                    video.style.width = '60%'
                    video.style.left = '20%'
                    video.style.position = 'relative'
                }
            }
        }
        let LogoUrl = Object.keys(publicJobDetail).length === 0 ? AstronautLogo : company.logoUrl;
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        return (
            <Fragment>
                {this.decidePage(
                    customColor,
                    backgroundImage,
                    company,
                    job,
                    show_due_date,
                    dueDate,
                    translations,
                )}
                {
                    customColor == '' ?
                        <div className={this.state.show_received_application ? 'hide' : ''} />
                        :
                        <Fragment>
                            <div className={this.state.show_received_application ? 'hide' : ''}>
                                <header className="header-career" style={{ background: "url(" + backgroundImage + ")" + customColor }} >
                                    <div className={`container ${backgroundImage == '' || backgroundImage == null || backgroundImage == 0 ? '' : 'invisible'}`}>
                                        <div className="flex-container img-container m-r-10 flex-center">
                                            <a href={company.website}
                                                className="text-white"
                                                target="_blank"
                                                rel="noopener noreferrer">
                                                <img
                                                    className="company-logo img-responsive"
                                                    src={LogoUrl}
                                                    alt={company.title}
                                                    onError={this.imageOnError} />
                                            </a>
                                        </div>
                                        
                                    </div>
                                </header>
                                {Object.keys(publicJobDetail).length === 0 ?
                                    <Fragment>
                                        <section className='custom-error vertical-item--center'>
                                            <div className="error-404 flex-container">
                                                <div className="text-404 horizontal-item--center">
                                                    <div>
                                                        <label>{translate('en', '404_OOPS')}</label>
                                                        <div className="desktop-hide">
                                                            {renderHTML(translate('en', '404_DESKTOP_HIDE_TEXT'))}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='div-image'><img src={ImgError404} /></div>
                                                <div className="mobile-hide">
                                                    <div className="text-404">
                                                        {renderHTML(translate('en', '404_MOBILE_HIDE_TEXT'))}
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </Fragment>
                                    :
                                    <Fragment>
                                        <section className="p-t-40 p-b-24 bg-gray" id="registration-form">
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col-sm-7 col-md-7">
                                                        <div>
                                                            {isEmpty(job_video_url) ?
                                                                ''
                                                                :
                                                                <div className="video-box" onClick={(e) => this.handleVideoClick(company.id, videoId)}>
                                                                    <Video style={videoStyle} id="video-src" src={job_video_url}>
                                                                    </Video>
                                                                </div>
                                                            }
                                                            <div className="div-apply-now-button mobile-hide"><a href="#section-registration"><button className="button button__primary button--medium medium-rounded button-apply-now"
                                                                ref={(node) => {
                                                                    if (node) {
                                                                        node.style.setProperty("background", colorCondition, "important");
                                                                        node.style.setProperty("border", '0', "important");
                                                                    }
                                                                }}>{call_action_message} <i className="fa fa-chevron-down font-18"></i></button></a></div>
                                                            <section>
                                                                <div className="div-wisiwig" dangerouslySetInnerHTML={this.createMarkup(job.aboutDescription)} />
                                                            </section>
                                                            <section className={`div-soc-container flex-container flex-between align-items-center m-t-40 ${socialMedia.length > 0 ? '' : 'hidden'}`}>
                                                                <div>{t(translations, 'LABEL_SHARE')}</div>
                                                                <div className="desktop-hide">
                                                                    <div className="flex-container">
                                                                        <a onClick={() => this.handlePopUp('email')} title="Email" className={socialMedia.includes('email') ? '' : 'hide'}><div className="div-soc-med flex-container flex-between align-items-center email">Email<i className="fa fa-envelope"></i></div></a>
                                                                        <a onClick={() => this.handlePopUp('facebook')} title="Facebook" className={socialMedia.includes('facebook') ? '' : 'hide'}><div className="div-soc-med flex-container flex-between align-items-center facebook">Facebook<i className="fa fa-facebook-official"></i></div></a>
                                                                        <a onClick={() => this.handlePopUp('twitter')} title="Twitter" className={socialMedia.includes('twitter') ? '' : 'hide'}><div className="div-soc-med flex-container flex-between align-items-center twitter">X<img src={logoX} /></div></a>
                                                                        <a onClick={() => this.handlePopUp('linkedin')} title="LinkedIn" className={socialMedia.includes('linkedin') ? '' : 'hide'}><div className="div-soc-med flex-container flex-between align-items-center linkedin">LinkedIn<i className="fa fa-linkedin"></i></div></a>
                                                                        <a onClick={() => this.handlePopUp('Whatsapp')} title="WhatsApp" className={socialMedia.includes('Whatsapp') ? '' : 'hide'}><div className="div-soc-med flex-container flex-between align-items-center whatsapp">WhatsApp<i className="fa fa-whatsapp"></i></div></a>
                                                                    </div>
                                                                </div>
                                                                <div className="mobile-hide">
                                                                    <div className="flex-container">
                                                                        <a onClick={() => this.handlePopUp('email')} title="Email" className={socialMedia.includes('email') ? '' : 'hide'}><div className="div-soc-med-small flex-container flex-between align-items-center email"><i className="fa fa-envelope"></i></div></a>
                                                                        <a onClick={() => this.handlePopUp('facebook')} title="Facebook" className={socialMedia.includes('facebook') ? '' : 'hide'}><div className="div-soc-med-small flex-container flex-between align-items-center facebook"><i className="fa fa-facebook-official"></i></div></a>
                                                                        <a onClick={() => this.handlePopUp('twitter')} title="Twitter" className={socialMedia.includes('twitter') ? '' : 'hide'}><div className="div-soc-med-small flex-container flex-between align-items-center twitter"><img src={logoX} /></div></a>
                                                                        <a onClick={() => this.handlePopUp('linkedin')} title="LinkedIn" className={socialMedia.includes('linkedin') ? '' : 'hide'}><div className="div-soc-med-small flex-container flex-between align-items-center linkedin"><i className="fa fa-linkedin"></i></div></a>
                                                                        <a onClick={() => this.handlePopUp('Whatsapp')} title="WhatsApp" className={socialMedia.includes('Whatsapp') ? '' : 'hide'}><div className="div-soc-med-small flex-container flex-between align-items-center whatsapp"><i className="fa fa-whatsapp"></i></div></a>
                                                                    </div>
                                                                </div>
                                                            </section>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-5 col-md-5">
                                                        {true ?
                                                            <section id="section-registration" className="registration">
                                                                <div className="div-apply-now">
                                                                    <p style={handleStyleApply()}>{call_action_message}</p>
                                                                    <hr style={handleStyleApplyBorder()} />
                                                                </div>
                                                                <form onSubmit={handleSubmit(this.handleSaveData)} id="form-registration" className="vertical-form">
                                                                    {/* <Prompt when={true} message={location => `Data is not saved! Are you sure you want to leave?`} /> */}
                                                                    <div className="form-group">
                                                                        <label>{this.renderCVupload(true)}</label>
                                                                        {this.renderCVupload()}

                                                                        <Field
                                                                            name="company_id"
                                                                            type="hidden"
                                                                            component="input" />
                                                                        <Field
                                                                            name="job_id"
                                                                            type="hidden"
                                                                            component="input" />
                                                                        <Field
                                                                            name="interview_code"
                                                                            type="hidden"
                                                                            component="input" />
                                                                        <label>{t(translations, "LABEL_FULL_NAME")}</label>
                                                                        <Field
                                                                            name="fullname"
                                                                            type="text"
                                                                            onFocus={this.inputFocus}
                                                                            onBlur={this.inputBlur}
                                                                            placeholder={t(translations, 'LABEL_FULL_NAME')}
                                                                            component="input"
                                                                            disabled={isAnyUploadInProgress}
                                                                        />
                                                                        <Field name="fullname" component={this.renderError} />
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>{t(translations, 'LABEL_PREFERRED_NAME')}</label>
                                                                        <Field
                                                                            name="preferred_name"
                                                                            type="text"
                                                                            onFocus={this.inputFocus}
                                                                            onBlur={this.inputBlur}
                                                                            placeholder={t(translations, 'LABEL_PREFERRED_NAME')}
                                                                            component="input"
                                                                            disabled={isAnyUploadInProgress} />
                                                                        <Field name="preferred_name" component={this.renderError} />
                                                                    </div>
                                                                    <div className="form-group" style={show_email ? {} : { display: 'none' }}>
                                                                        <label>{t(translations, 'LABEL_EMAIL_ADDRESS')}</label>
                                                                        <Field
                                                                            name="email"
                                                                            type="text"
                                                                            onFocus={this.inputFocus}
                                                                            onBlur={this.inputBlur}
                                                                            placeholder={t(translations, 'LABEL_EMAIL_ADDRESS')}
                                                                            component="input"
                                                                            normalize={normalizeEmail}
                                                                            disabled={isAnyUploadInProgress} />
                                                                        <Field name="email" component={this.renderError} />
                                                                    </div>
                                                                    <div className="form-group" style={show_email ? {} : { display: 'none' }}>
                                                                        <label>{t(translations, 'LABEL_CONFIRM_EMAIL_ADDRESS')}</label>
                                                                        <Field
                                                                            name="email2"
                                                                            type="text"
                                                                            onFocus={this.inputFocus}
                                                                            onBlur={this.inputBlur}
                                                                            placeholder={t(translations, 'LABEL_CONFIRM_EMAIL_ADDRESS')}
                                                                            component="input"
                                                                            normalize={normalizeEmail}
                                                                            disabled={isAnyUploadInProgress} />
                                                                        <Field name="email2" component={this.renderError} />
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>{t(translations, 'LABEL_MOBILE_NUMBER')}</label>
                                                                        <Field
                                                                            name="phone"
                                                                            type="text"
                                                                            onFocus={this.inputFocus}
                                                                            onBlur={this.inputBlur}
                                                                            placeholder={t(translations, 'LABEL_MOBILE_NUMBER')}
                                                                            component="input"
                                                                            disabled={isAnyUploadInProgress} />
                                                                        <Field name="phone" component={this.renderError} />
                                                                        {
                                                                            showWAoption &&
                                                                            <div className={`form-group whatsapp-box`}>
                                                                                <label className="inline-content normal checkbox-container m-b-15">
                                                                                    <Field
                                                                                        name="whatsapp_notification"
                                                                                        type="checkbox"
                                                                                        onClick={this.handleWhatsappReminderClick}
                                                                                        component="input"
                                                                                        checked={isWhatsappReminder}
                                                                                        className="btn-checkbox m-r-10" />{t(translations, 'LABEL_WHATSAPP_REMINDER')}<span className="checkmark"></span>
                                                                                </label>
                                                                                <label className="label-gdpr-text">{t(translations, 'DESC_WHATSAPP_REMINDER')}</label>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>{t(translations, 'PROFILE_LOCATION_DOMICILE')} <span style={{ fontWeight: 'normal' }}>(Optional)</span></label>
                                                                        <Field
                                                                            name="location"
                                                                            type="text"
                                                                            onFocus={this.inputFocus}
                                                                            onBlur={this.inputBlur}
                                                                            placeholder={t(translations, 'PROFILE_LOCATION_DOMICILE')}
                                                                            component="input"
                                                                            disabled={isAnyUploadInProgress} />
                                                                        <Field name="location" component={this.renderError} />
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>{t(translations, 'PROFILE_ADDRESS')} <span style={{ fontWeight: 'normal' }}>(Optional)</span></label>
                                                                        <Field
                                                                            name="address"
                                                                            component="textarea"
                                                                            onFocus={this.inputFocus}
                                                                            onBlur={this.inputBlur}
                                                                            placeholder={t(translations, 'PROFILE_ADDRESS')}
                                                                            rows="4"
                                                                            style={{ minHeight: '70px', resize: 'vertical' }}
                                                                            disabled={isAnyUploadInProgress} />
                                                                        <Field name="address" component={this.renderError} />
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>{t(translations, 'PROFILE_DATE_OF_BIRTH')} <span style={{ fontWeight: 'normal' }}>(Optional)</span></label>
                                                                        <div 
                                                                            style={{ 
                                                                                position: 'relative',
                                                                                cursor: 'pointer'
                                                                            }}
                                                                            onClick={(e) => {
                                                                                // Find the date input and trigger click
                                                                                const dateInput = e.currentTarget.querySelector('input[type="date"]');
                                                                                if (dateInput && !isAnyUploadInProgress) {
                                                                                    dateInput.focus();
                                                                                    dateInput.showPicker && dateInput.showPicker();
                                                                                }
                                                                            }}>
                                                                            <Field
                                                                                name="date_of_birth"
                                                                                type="date"
                                                                                onFocus={this.inputFocus}
                                                                                onBlur={this.inputBlur}
                                                                                component="input"
                                                                                className="form-control"
                                                                                style={{ 
                                                                                    width: '100%', 
                                                                                    cursor: 'pointer',
                                                                                    padding: '12px 15px',
                                                                                    fontSize: '14px',
                                                                                    lineHeight: '1.42857143',
                                                                                    minHeight: '38px'
                                                                                }}
                                                                                disabled={isAnyUploadInProgress} />
                                                                        </div>
                                                                        <Field name="date_of_birth" component={this.renderError} />
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>{t(translations, 'PROFILE_NATIONALITY')} <span style={{ fontWeight: 'normal' }}>(Optional)</span></label>
                                                                        <Field
                                                                            name="nationality"
                                                                            type="text"
                                                                            onFocus={this.inputFocus}
                                                                            onBlur={this.inputBlur}
                                                                            placeholder={t(translations, 'PROFILE_NATIONALITY')}
                                                                            component="input"
                                                                            disabled={isAnyUploadInProgress} />
                                                                        <Field name="nationality" component={this.renderError} />
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>{t(translations, 'PROFILE_LINKEDIN')} <span style={{ fontWeight: 'normal' }}>(Optional)</span></label>
                                                                        <Field
                                                                            name="linkedin_url" 
                                                                            type="text"
                                                                            onFocus={this.inputFocus}
                                                                            onBlur={this.inputBlur}
                                                                            placeholder="http://"
                                                                            component="input"
                                                                            disabled={isAnyUploadInProgress} />
                                                                        <Field name="linkedin_url" component={this.renderError} />
                                                                    </div>
                                                                    <hr style={{ border: '0.7px solid #ddd', margin: '21px 0' }} />
                                                                    <div className="form-group">
                                                                        <label>{t(translations, 'PROFILE_EMPLOYMENT_HISTORY')} <span style={{ fontWeight: 'normal' }}>(Optional)</span></label>
                                                                        <FieldArray
                                                                            name="employment_history"
                                                                            component={this.renderEmploymentHistoryFields}
                                                                        />
                                                                    </div>

                                                                    {/* Educational Background Section */}
                                                                    <hr style={{ border: '0.7px solid #ddd', margin: '21px 0' }} />
                                                                    <div className="form-group">
                                                                        <label className="form-label-bold">{t(translations, 'PROFILE_EDUCATIONAL_BACKGROUND')} <span style={{ fontWeight: 'normal' }}>(Optional)</span></label>
                                                                        <FieldArray
                                                                            name="education_background"
                                                                            component={this.renderEducationBackgroundFields}
                                                                        />
                                                                    </div>																	{/* Skills & Certifications Section */}
                                                                    <hr style={{ border: '0.7px solid #ddd', margin: '21px 0' }} />																	
                                                                    <div className="form-group">
                                                                        <label className="form-label-bold" style={{ marginBottom: '15px' }}>{t(translations, 'PROFILE_SKILLS_CERTIFICATIONS')} <span style={{ fontWeight: 'normal' }}>(Optional)</span></label>
                                                                        
                                                                        {/* Check if there's API data for skills or if user manually added skills */}
                                                                        {!this.state.showSkillsForms && !(formValues && (formValues.soft_skills || formValues.hard_skills)) ? (
                                                                            <div>
                                                                                <div style={{ 
                                                                                    padding: '4px',
                                                                                    fontSize: '13px',
                                                                                    color: '#808080',
                                                                                    marginBottom: '3px'
                                                                                }}>
                                                                                    No skills & certifications have been added to this candidate.
                                                                                </div>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn"
                                                                                    style={{ 
                                                                                        color: '#564FDB', 
                                                                                        backgroundColor: 'transparent',
                                                                                        border: 'none',
                                                                                        borderRadius: '0',
                                                                                        padding: '8px 0'
                                                                                    }}
                                                                                    onClick={() => {
                                                                                        this.setState({ showSkillsForms: true });
                                                                                    }}
                                                                                    disabled={isAnyUploadInProgress}>
                                                                                    <i className="fa fa-plus m-r-5"></i>
                                                                                    Add Skill & Certification
                                                                                </button>
                                                                            </div>
                                                                        ) : (
                                                                            <div>
                                                                                {/* Soft Skills */}
                                                                                <div className="form-group">
                                                                                    <Field
                                                                                        name="soft_skills"
                                                                                        component={RenderTagsInput}
                                                                                        label={t(translations, 'PROFILE_SOFT_SKILLS')}
                                                                                        customColor={colorCondition}
                                                                                        disabled={isAnyUploadInProgress}
                                                                                    />
                                                                                    <Field name="soft_skills" component={this.renderError} />
                                                                                </div>

                                                                                {/* Hard Skills */}
                                                                                <div className="form-group">
                                                                                    <Field
                                                                                        name="hard_skills"
                                                                                        component={RenderTagsInput}
                                                                                        label={t(translations, 'PROFILE_HARD_SKILLS')}
                                                                                        customColor={colorCondition}
                                                                                        disabled={isAnyUploadInProgress}
                                                                                    />
                                                                                    <Field name="hard_skills" component={this.renderError} />
                                                                                </div>
                                                                            </div>
                                                                        )}

                                                                        {/* Languages */}
                                                                    <hr style={{ border: '0.7px solid #ddd', margin: '21px 0' }} />
                                                                        <div className="form-group">
                                                                            <FieldArray
                                                                                name="languages"
                                                                                component={this.renderLanguageFields}
                                                                            />
                                                                        </div>

                                                                        {/* Certifications */}
                                                                        <div className="form-group">
                                                                            <FieldArray
                                                                                name="certifications"
                                                                                component={this.renderCertificationFields}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    {/* Key Achievements Section */}
                                                                    <div className="form-group">
                                                                        <label className="form-label-bold">{t(translations, 'PROFILE_KEY_ACHIEVEMENT')} <span style={{ fontWeight: 'normal' }}>(Optional)</span></label>
                                                                        <FieldArray
                                                                            name="key_achievements"
                                                                            component={this.renderKeyAchievementFields}
                                                                        />
                                                                    </div>

                                                                    {job.requireCv !== 0 ?
                                                                        <div className="form-group">
                                                                            {/* <div className="row m-0">
                                                            <div className="col-md-5 p-0"><label>{job_document_type}</label></div>
                                                            <div className="col-md-7 text-use-pdf p-0"><label className="normal">{t(translations, 'LABEL_NOTE_UPLOAD_PDF')} 5MB</label></div>
                                                        </div>
                                                        <div className="row m-0">
                                                            <div className="input-group-cv m-t-5">
                                                                <label className="form-control upload-cv m-t-0">
                                                                    <p className="cv-file">{cvName==''?job_document_type:cvName}</p>
                                                                    <p className="uploaded-cv"></p>
                                                                    <input
                                                                    name="cv"
                                                                    type="file"
                                                                    className="upload-cv"
                                                                    placeholder="Curriculum Vitae"
                                                                    onChange={this.handleFileSave}
                                                                    component="input" />


                                                                <Field
                                                                    name="cv"
                                                                    type="text"
                                                                    className="hidden"
                                                                    placeholder="Curriculum Vitae"
                                                                    component="input" />
                                                                
                                                                <i className={`fa ${iconClass} font-28`} style={{color:iconColor}}></i>
                                                                </label>
                                                            </div>
                                                            {uploadProgress == 'up'?
                                                            <ProgressBarAngga progressVal={this.state.uploadFilePercentage}/>
                                                            : null}
                                                            {!isEmpty(errors) ? <span className="error">{errors.file}</span> : <Field name="cv" component={this.renderErrorCV}/>}


                                                        </div> */}
                                                                        </div>
                                                                        : null
                                                                    }
                                                                    <div className="form-group hidden">
                                                                        <div className="col-md-10 p-0"><label>{t(translations, 'LABEL_EXPERIENCE_EXPECT')} <a href="https://astrnt.co" target="_blank"><b style={{ color: customColor }}>Astronaut</b></a>?</label></div>
                                                                        <div className="col-md-2 text-right p-0"><label>{countText}<font className="normal">/1000</font></label></div>
                                                                        <textarea
                                                                            name="experience"
                                                                            onFocus={this.inputFocus}
                                                                            onBlur={this.inputBlur}
                                                                            value={formValues.experience}
                                                                            onChange={this.handleChangeTextArea}
                                                                            placeholder={t(translations, 'LABEL_EXPERIENCE_EXPECT') + 'Astronaut?'}
                                                                            className="form-control h-100"
                                                                        />

                                                                        <Field
                                                                            name="experience"
                                                                            component="textarea"
                                                                            placeholder={t(translations, 'LABEL_EXPERIENCE_EXPECT') + 'Astronaut?'}
                                                                            className="form-control h-100 hidden" />
                                                                        <Field name="experience" component={this.renderError} />
                                                                    </div>
                                                                    {additionalField.map((addInfo, index) => (
                                                                        <div key={index}>
                                                                            {addInfo.id === 77 ?
                                                                                <div className="form-group m-t-30">
                                                                                    <div className="label capitalize">{addInfo.label}</div>
                                                                                    <div className="form-group sm">
                                                                                        <Field
                                                                                            name={`${snakeCase(addInfo.label)}-${addInfo.id}`}
                                                                                            type="radio"
                                                                                            className={`js-additional-fields-${addInfo.id}`}
                                                                                            component="input"
                                                                                            onChange={() => this.checkExperience('0')}
                                                                                            checked={experience === '0'} /> {t(translations, 'LABEL_LESS_THAN')} 1 {t(translations, 'LABEL_YEAR')}
                                                                                    </div>
                                                                                    <div className="form-group sm">
                                                                                        <Field
                                                                                            name={`${snakeCase(addInfo.label)}-${addInfo.id}`}
                                                                                            type="radio"
                                                                                            className={`js-additional-fields-${addInfo.id}`}
                                                                                            component="input"
                                                                                            onChange={() => this.checkExperience('1')}
                                                                                            checked={experience === '1'} /> 1 {t(translations, 'LABEL_YEAR')}
                                                                                    </div>
                                                                                    <div className="form-group sm">
                                                                                        <Field
                                                                                            name={`${snakeCase(addInfo.label)}-${addInfo.id}`}
                                                                                            type="radio"
                                                                                            className={`js-additional-fields-${addInfo.id}`}
                                                                                            component="input"
                                                                                            onChange={() => this.checkExperience('2')}
                                                                                            checked={experience === '2'} /> {t(translations, 'LABEL_MORE_THAN')} 1 {t(translations, 'LABEL_YEAR')}
                                                                                    </div>
                                                                                    <div><span id={`js-is-error-mandatory-${addInfo.id}`} className="error"></span></div>
                                                                                </div>
                                                                                :
                                                                                this.renderAdditionalField(addInfo, index)

                                                                            }
                                                                        </div>
                                                                    ))}

                                                                    <input
                                                                        ref={this.uploadAdditionalFieldRef}
                                                                        type="file"
                                                                        onClick={(e) => { e.target.value = null }}
                                                                        onChange={this.handleAdditionalFileSave}
                                                                        style={{ display: 'none' }}
                                                                    />

                                                                    <div className='div-container-multidoc'>
                                                                        {this.renderMultiDocForm()}
                                                                        <input
                                                                            ref={this.uploadRef}
                                                                            type="file"
                                                                            onClick={(e) => { e.target.value = null }}
                                                                            onChange={this.handleAttachmentUpload}
                                                                            style={{ display: 'none' }}
                                                                        />
                                                                        {/* <div className='div-multidoc-action'>
                                                                <div className='horizontal-item--between m-b-8'>
                                                                    <label>CV/Resume</label>
                                                                    <div className='div-action-icon'>
                                                                        <i className='icon-i-add-link hide'></i>
                                                                        <i className='icon-i-add-file m-l-8'></i>
                                                                    </div>
                                                                </div>
                                                                <FileUploader/>
                                                                <LinkInputer/>
                                                            </div>
                                                            <div className='div-multidoc-action'>
                                                                <div className='horizontal-item--between'>
                                                                    <label>Other Supporting Documents <span>(Optional)</span></label>
                                                                    <div className='div-action-icon'>
                                                                        <i className='icon-i-add-link'></i>
                                                                        <i className='icon-i-add-file m-l-8 disabled'></i>
                                                                    </div>
                                                                </div>
                                                            </div> */}
                                                                    </div>

                                                                    <label>{t(translations, 'LABEL_AGREE_ASTRNT')}</label>
                                                                    <div
                                                                        className={`form-group main-gdpr-fluid`}
                                                                        style={isConsent ? { backgroundColor: colorCondition } : {}}>
                                                                        <label className="label-gdpr-text">{gdpr_text}</label>
                                                                        <label className="inline-content normal checkbox-container m-b-15">
                                                                            <Field
                                                                                name="gdpr"
                                                                                type="checkbox"
                                                                                onClick={this.handleConsentClick}
                                                                                component="input"
                                                                                checked={isConsent}
                                                                                className="btn-checkbox m-r-10" />{gdpr_agreement_text}<span className="checkmark"></span>
                                                                        </label>
                                                                    </div>

                                                                    {publicJobDetail.compliance ?
                                                                        <Fragment>
                                                                            <label>{t(translations, 'LABEL_AGREE_COMPANY')}{company.title}</label>
                                                                            <div
                                                                                className={`form-group main-gdpr-fluid`}
                                                                                style={isCompliance ? { backgroundColor: colorCondition } : {}}>

                                                                                <label className="inline-content normal checkbox-container" style={{ whiteSpace: 'pre-wrap' }}>
                                                                                    <Field
                                                                                        name="compliance"
                                                                                        type="checkbox"
                                                                                        onClick={this.handleConsentClick}
                                                                                        component="input"
                                                                                        checked={isCompliance}
                                                                                        className="btn-checkbox m-r-10" />{publicJobDetail.compliance}<span className="checkmark"></span>
                                                                                </label>
                                                                            </div>
                                                                        </Fragment>
                                                                        : null}

                                                                    <center className="m-t-30">
                                                                        <p className="label-click-continue" dangerouslySetInnerHTML={{ __html: t(translations, 'LABEL_CONTINUE_DESC') }} />
                                                                        <button
                                                                            id="btn-submit"
                                                                            type="submit"
                                                                            className={`button button__primary button--medium medium-rounded button-continue ${this.state.isConsent ? "is-on" : ""}`}
                                                                            onClick={this.handleClickAfterSave}
                                                                            style={{ backgroundColor: colorCondition }}
                                                                            disabled={isAnyUploadInProgress}
                                                                            ref={(node) => {
                                                                                if (node) {
                                                                                    // node.style.setProperty("background", colorCondition, "important");
                                                                                    node.style.setProperty("border", '0', "important");
                                                                                }
                                                                            }}
                                                                            disabled={publicJobDetail.compliance ? isConsent && isCompliance ? false : true
                                                                                :
                                                                                !isConsent}>{t(translations, 'BUTTON_CONTINUE')} <i className="fa fa-chevron-right"></i></button>
                                                                    </center>
                                                                </form>
                                                            </section>
                                                            :
                                                            ''
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                        <section className="p-t-24 p-b-24 hide animate-all" id="registration-form__success">
                                            <div className="container">
                                                {this.renderSubmitSuccess()}
                                            </div>
                                        </section>
                                        <div className="footer-astrnt">
                                            <section>
                                                Powered by <a><img src={imgAstrntFooter} /></a> All Rights Reserved.
                                            </section>
                                        </div>
                                    </Fragment>
                                }


                                {/*
                    <footer className="listing-footer">
                        <div className="flex-container flex-between">
                            <p><a href={company.website} target="_blank" rel="noopener noreferrer"><i className="fa fa-globe"></i> {company.website}</a></p>
                            <div className="copy">
                                <a href="http://astrnt.co">Powered by ASTRNT</a>
                            </div>
                        </div>
                    </footer>
                    */}
                                {/* <SweetAlert {...globalSweetAlertData} /> */}
                            </div>
                        </Fragment>
                }
            </Fragment>

        )
    }
}

CompanyTalentPoolByCode.propTypes = {
    errors: PropTypes.object,
    publicJobGetDetail: PropTypes.func.isRequired,
    companySlug: PropTypes.string,
    jobSlugs: PropTypes.string,
    registrationSaveData: PropTypes.func.isRequired,
    publicJobDetail: PropTypes.object.isRequired,
    fields: PropTypes.array.isRequired,
    publicJobGetDetailAsync: PropTypes.func.isRequired,
}

CompanyTalentPoolByCode = reduxForm({
    form: 'CompanyTalentPoolByCode',
    enableReinitialize: true,
    validate,
    fields
})(CompanyTalentPoolByCode)
const selector = formValueSelector('CompanyTalentPoolByCode')

const mapStateToProps = (state, ownProps) => {
    const formState = getFormValues('CompanyTalentPoolByCode')(state)
    const publicJobDetail = state.publicJobDetail.toJS()
    const company = publicJobDetail.company || {}
    const job = publicJobDetail.job || {}

    const initialValues = {
        company_id: company.id,
        job_id: job.id,
        interview_code: job.open_code,
        cv: '',
        experience: '',
        whatsapp_notification: Boolean(job.whatsapp_notification),
    }


    return {
        documentAttachment: state.documentAttachment.toJS(),
        publicJobDetail: state.publicJobDetail.toJS(),
        translationjob: state.publicJobDetail.toJS(),
        errors: state.registrationSaveDataError.toJS(),
        publicJobCustom: state.publicJobCustom.toJS(),
        error_email_exists: state.registrationEmailDuplicate,
        globalSweetAlertData: state.globalSweetAlertData.toJS(),
        openCode: ownProps.match.params.code,
        initialValues,
        formValues: selector(
            state,
            'cv',
            'experience',
            'whatsapp_notification',
            'employment_history',
            'education_background',
            'soft_skills',
            'hard_skills',
            'languages',
            'certifications',
            'key_achievements'
        ),
        formState
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        changeFieldValue: (field, value) => dispatch(change('CompanyTalentPoolByCode', field, value, true, true)),
        touchForm: (field) => dispatch(touch('CompanyTalentPoolByCode', field)),
        stopAsyncValidationForm: (object) => dispatch(stopAsyncValidation('CompanyTalentPoolByCode', object)),
        globalHideSweetAlert: () => dispatch(globalHideSweetAlert()),
        globalAddSweetAlertData: (options) => dispatch(globalAddSweetAlertData(options)),
        registrationSaveData: (companySlug, jobSlugs, values) => dispatch(registrationSaveData(companySlug, jobSlugs, values)),
        registrationTalentPoolSaveDataCode: (openCode, values) => dispatch(registrationTalentPoolSaveDataCode(openCode, values)),
        publicJobGetDetail: (companySlug, jobSlugs) => dispatch(publicJobGetDetail(companySlug, jobSlugs)),
        publicTalentPoolGetDetailCode: (openCode) => dispatch(publicTalentPoolGetDetailCode(openCode)),
        publicJobGetDetailAsync: (publicJobDetail) => dispatch(publicJobGetDetailAsync(publicJobDetail)),
        globalAddSweetAlertData: (option) => dispatch(globalAddSweetAlertData(option)),
        globalHideSweetAlert: () => dispatch(globalHideSweetAlert()),
        registrationSaveDataError: (error) => dispatch(registrationSaveDataError(error)),
        reset: (formName) => dispatch(reset(formName)),
        accessLog: (companyId, key, id) => accessLog(companyId, key, id),
        docAttachment: (file_attachment) => dispatch(docAttachment(file_attachment)),
        docAttachmentUpload: (company_id, file, curr_index, indexDocument, up_time) => dispatch(docAttachmentUpload(company_id, file, curr_index, indexDocument, up_time)),
        docAttachmentCV: (company_id, file, curr_index, indexDocument, up_time) => dispatch(docAttachmentCV(company_id, file, curr_index, indexDocument, up_time)),
        send: (company_id, file, extension, fileName, curr_index, end, start, size, new_file) => dispatch(send(company_id, file, extension, fileName, curr_index, end, start, size, new_file)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyTalentPoolByCode)
